/* Terra-Impact JS asset — extracted from terra-impact.liquid in V67.
   Pure ES, no Liquid. Section file populates window.__terraImpactConfig
   keyed by section.id before this script loads (or alongside via
   DOMContentLoaded — initAll handles either order).
*/
(function(){
      function initTerraImpact(sectionId){
        const cfg = (window.__terraImpactConfig || {})[sectionId];
        if (!cfg) return;
        const root = document.getElementById('terra-impact-' + sectionId);
        if (!root || root.dataset.terraInit === 'true') return;
        root.dataset.terraInit = 'true';

        const MARKER_SIZE_MM = 20;
        const RECTIFIED_PX_PER_MM = 6.5;
        /* TT1-TT5 are SQUARE and carry a single spacingMm. TT10-TT17 are
           RECTANGULAR and carry spacingXMm/spacingYMm instead. Spacings are
           centre-to-centre between markers. Keys and numbers are kept
           byte-identical to the Terra-Confirm app engine
           (apps/terra-confirm/www/terra-impact-engine.js) so a sheet analysed
           on the web and in the app rectifies to exactly the same geometry. */
        const PRESETS = {
          'impact-75':  { label: 'TT1', spacingMm: 75  },
          'impact-100': { label: 'TT2', spacingMm: 100 },
          'impact-120': { label: 'TT3', spacingMm: 120 },
          'impact-150': { label: 'TT4', spacingMm: 150 },
          'impact-180': { label: 'TT5', spacingMm: 180 },
          /* 2026-08-18: TT6-TT9 (the 2026-08-03 inch-grid rectangles) are GONE,
             replaced by the 100m MOA generation the printed sheets and the app
             actually use. This asset was a generation behind: every QR carries
             ?m=TT10..TT17 and NONE of them resolved here, so applyUrlParams
             silently dropped the code and left the default TT3 selected - a
             120mm round preset measured against an A3 rectangle, with no
             warning. Keeping both generations was never an option either: the
             old rectangles sit 1-2% from these (245 vs 247, 365 vs 370), close
             enough that a wrong manual pick returns a plausible WRONG scope
             correction rather than failing visibly. Nothing had shipped on
             either side, so they are deleted, not aliased. Codes are never
             recycled.
                TT10 A3 landscape       TT11 A4 landscape
                TT12 A3 portrait        TT13 A4 portrait
                TT14 Tabloid landscape  TT15 Letter landscape
                TT16 Tabloid portrait   TT17 Letter portrait                  */
          'impact-370x247':     { label: 'TT10', spacingXMm: 370,   spacingYMm: 247   },
          'impact-247x160':     { label: 'TT11', spacingXMm: 247,   spacingYMm: 160   },
          'impact-247x370':     { label: 'TT12', spacingXMm: 247,   spacingYMm: 370   },
          'impact-160x247':     { label: 'TT13', spacingXMm: 160,   spacingYMm: 247   },
          'impact-381.8x229.4': { label: 'TT14', spacingXMm: 381.8, spacingYMm: 229.4 },
          'impact-229.4x165.9': { label: 'TT15', spacingXMm: 229.4, spacingYMm: 165.9 },
          'impact-229.4x381.8': { label: 'TT16', spacingXMm: 229.4, spacingYMm: 381.8 },
          'impact-165.9x229.4': { label: 'TT17', spacingXMm: 165.9, spacingYMm: 229.4 }
        };

        const gid = (name) => document.getElementById(`${name}-${sectionId}`);
        const els = {
          fileInput: gid('fileInput'),
          cameraInput: gid('cameraInput'),
          distanceM: gid('distanceM'),
          threshold: gid('threshold'),
          thresholdValue: gid('thresholdValue'),
          thresholdAuto: gid('thresholdAuto'),
          thresholdEffective: gid('thresholdEffective'),
          rerunBtn: gid('rerunBtn'),
          editBtn: gid('editBtn'), // V35: kept for any legacy lookups; null when the dual buttons are present
          // V35: side-by-side Add / Delete shot buttons (replace single editBtn toggle).
          addShotBtn: gid('addShotBtn'),
          deleteShotBtn: gid('deleteShotBtn'),
          // V35: "No cold bore" toggle in the cold-bore row.
          noColdBoreToggle: gid('noColdBoreToggle'),
          lockRectified: gid('lockRectified'),
          lockHint: gid('lockHint'),
          clearShotsBtn: gid('clearShotsBtn'),
          exportCsvBtn: gid('exportCsvBtn'),
          fineTuneToggleBtn: gid('fineTuneToggleBtn'),
          fineTuneContent: gid('fineTuneContent'),
          resetFineTuneBtn: gid('resetFineTuneBtn'),
          transferBtn: gid('transferBtn'),
          saveToConfirmBtn: gid('saveToConfirmBtn'),
          saveSessionBtn: gid('saveSessionBtn'),
          loadSessionInput: gid('loadSessionInput'),

          loadCard: gid('loadCard'),
          fineTuneCard: gid('fineTuneCard'),
          sourceCard: gid('sourceCard'),
          rectifiedCard: gid('rectifiedCard'),
          // V27: measurementCard split into expectedCard + advancedCard.
          advancedCard: gid('advancedCard'),
          advancedToggleBtn: gid('advancedToggleBtn'),
          advancedContent: gid('advancedContent'),
          // V29: new workflow elements
          presetCard: gid('presetCard'),
          lockSourceCard: gid('lockSourceCard'),
          // V32: rotate-source button (90deg-CW)
          rotateSourceBtn: gid('rotateSourceBtn'),
          lockSourceBtn: gid('lockSourceBtn'),
          lockSourceStatus: gid('lockSourceStatus'),
          expectedCard: gid('expectedCard'),
          detectShotsBtn: gid('detectShotsBtn'),
          coldBoreBtn: gid('coldBoreBtn'),
          // V31: cold-bore POI metric cards
          coldBorePoiX: gid('coldBorePoiX'),
          coldBorePoiY: gid('coldBorePoiY'),
          coldBoreXMetric: gid('coldBoreXMetric'),
          coldBoreYMetric: gid('coldBoreYMetric'),
          lockPill: gid('lockPill'),
          lockBadge: gid('lockBadge'),
          rightColumn: root.querySelector('.terra-right'),
          leftColumn: root.querySelector('.terra-left'),
          cornerInputs: [
            { x: gid('cornerTLX'), y: gid('cornerTLY') },
            { x: gid('cornerTRX'), y: gid('cornerTRY') },
            { x: gid('cornerBRX'), y: gid('cornerBRY') },
            { x: gid('cornerBLX'), y: gid('cornerBLY') }
          ],
          cornerConf: {
            tl: document.getElementById(`markerConf-tl-${sectionId}`),
            tr: document.getElementById(`markerConf-tr-${sectionId}`),
            br: document.getElementById(`markerConf-br-${sectionId}`),
            bl: document.getElementById(`markerConf-bl-${sectionId}`)
          },
          shotsCount: gid('shotsCount'),
          groupSize: gid('groupSize'),
          poiX: gid('poiX'),
          poiY: gid('poiY'),
          // V28: shots metric wrapper + expected sub-element
          shotsMetric: gid('shotsMetric'),
          expectedShots: gid('expectedShots'),
          // V28: sticky mini-metrics bar
          miniMetrics: gid('miniMetrics'),
          miniShots: gid('miniShots'),
          miniGroup: gid('miniGroup'),
          miniPoiX: gid('miniPoiX'),
          miniPoiY: gid('miniPoiY'),
          statusText: gid('statusText'),
          // V30: preset selector is now a <select> dropdown; cache the
          // element for change-listener wiring and label sync.
          presetSelect: gid('presetSelect'),
          sourceCanvas: gid('sourceCanvas'),
          previewCanvas: gid('previewCanvas'),
          rectifiedCanvas: gid('rectifiedCanvas'),
          rectifiedWrap: gid('rectifiedWrap'),
        };

        const BROWSER_SAVE_KEY = `terra-impact-session-${sectionId}`;

        // V66: Terra-Confirm app page URL for the "Send to Terra-Confirm" handoff.
        // Populated by the section via cfg.confirmUrl; falls back to the
        // conventional page handle if unset.
        const CONFIRM_URL = (cfg && cfg.confirmUrl) ? cfg.confirmUrl : '/pages/terra-confirm';

        const state = {
          /* V65: unitSystem source of truth; init below may override from localStorage. */
          unitSystem: cfg.unitSystem,
          presetKey: 'impact-120',
          corners: null,
          shots: [],
          editMode: 'place',
          placingManualMarkers: false,
          manualCorners: [],
          rectifiedBaseImageData: null,
          poiOffsetMm: { x: 0, y: 0 },
          baseCorners: null,
          fineTuneOffsetsMm: [
            { x: 0, y: 0 },
            { x: 0, y: 0 },
            { x: 0, y: 0 },
            { x: 0, y: 0 }
          ],
          fineTuneAutoTimer: null,
          shotDetectionTimer: null,
          autoSaveTimer: null,
          isRestoringBrowserSave: false,
          lastSourceImageDataUrl: '',
          lockRectified: false,
          fineTuneCollapsed: true,
          rectifiedZoom: 1,
          rectifiedPan: { x: 0, y: 0 },
          isPanningRectified: false,
          lastPanPoint: null,
          pinchDistance: 0,
          // V24: Otsu auto-threshold computed per rectified image (null until
          // a detection pass has been run). The slider value is added to this
          // to produce the effective binary threshold.
          otsuThreshold: null,
          // V24: per-corner detection scores (0-1.5 range) and pass/fail from
          // the most recent marker detection pass. Used to paint the
          // confidence badges and inform status messages.
          cornerScores: { tl: 0, tr: 0, br: 0, bl: 0 },
          cornerFound: { tl: false, tr: false, br: false, bl: false },
          cornerFromFallback: false,
          // V25-A: name of the corner that was inferred by parallelogram
          // completion from the other 3 (tl|tr|br|bl), or null.
          predictedCorner: null,
          // V27: collapse-override flags. Set true when the user
          // manually taps a collapse toggle, so subsequent auto-collapse
          // logic (after detection) doesn't override their choice.
          fineTuneUserOverride: false,
          advancedCollapsed: true,
          advancedUserOverride: false,
          // V28: user-entered expected shot count (null = not set).
          // When set, Shots metric shows "n / expected" and tints amber
          // on mismatch. Remembered per-section via localStorage so the
          // same user's typical round count carries across sessions.
          expectedShots: null,
          // V28: memo of the last mismatch state so haptic "success"
          // only fires on the transition into match (not on every shot).
          lastMismatchState: null,
          // V28: memoised query results and listener flags for the
          // sticky mini-metrics bar so scroll handlers stay cheap.
          miniMetricsVisible: false,
          miniMetricsTop: -1,
          miniMetricsScrollBound: false,
          // V29 workflow state: sourceLocked / shotsDetected /
          // coldBoreShotIndex (V34: coldBoreMode removed; button cycles instead).
          sourceLocked: false,
          shotsDetected: false,
          coldBoreShotIndex: null,
          // V36: cached cold-bore POI offset (mm) so the Terra-Dial
          // transfer handler doesn\u2019t have to recompute it from canvas
          // pixel coords.
          coldBorePoiOffsetMm: null,
          // V35: when true, this group has no cold-bore shot. Disables
          // the cold-bore button, hides the cold-bore POI metric cards,
          // and forces coldBoreShotIndex to null.
          noColdBore: false,
        };

        function relocatePanels(){
          // V27: measurementCard is gone (split into shotActionsCard /
          // advancedCard, both in the left column unconditionally). Only
          // sourceCard and rectifiedCard move between columns.
          // V30: rectifiedCard now sits AFTER expectedCard on mobile so
          // the user enters their round count above the canvas.
          if (!els.sourceCard || !els.loadCard || !els.fineTuneCard || !els.rectifiedCard || !els.rightColumn || !els.leftColumn) return;

          if (window.innerWidth <= 1180){
            if (els.loadCard.nextElementSibling !== els.sourceCard){
              els.loadCard.insertAdjacentElement('afterend', els.sourceCard);
            }
            // Place the rectified canvas after expectedCard if it's
            // present, otherwise fall back to fineTuneCard.
            const anchor = els.expectedCard || els.fineTuneCard;
            if (anchor && anchor.nextElementSibling !== els.rectifiedCard){
              anchor.insertAdjacentElement('afterend', els.rectifiedCard);
            }
          } else {
            if (els.rightColumn.firstElementChild !== els.sourceCard){
              els.rightColumn.insertAdjacentElement('afterbegin', els.sourceCard);
            }
            if (els.sourceCard.nextElementSibling !== els.rectifiedCard){
              els.sourceCard.insertAdjacentElement('afterend', els.rectifiedCard);
            }
          }
        }

        function getPreset(){ return PRESETS[state.presetKey] || PRESETS['impact-120']; }
        function getSpacingXMm(){ const p = getPreset(); return p.spacingXMm != null ? p.spacingXMm : p.spacingMm; }
        function getSpacingYMm(){ const p = getPreset(); return p.spacingYMm != null ? p.spacingYMm : p.spacingMm; }
        function getReferenceMarginMm(){ return MARKER_SIZE_MM / 2; }
        function getTargetWidthMm(){ return getSpacingXMm() + MARKER_SIZE_MM; }
        function getTargetHeightMm(){ return getSpacingYMm() + MARKER_SIZE_MM; }
        function getRectifiedWidthPx(){ return Math.round(getTargetWidthMm() * RECTIFIED_PX_PER_MM); }
        function getRectifiedHeightPx(){ return Math.round(getTargetHeightMm() * RECTIFIED_PX_PER_MM); }
        /* px/mm is UNIFORM on both axes — width and height both derive from the
           same RECTIFIED_PX_PER_MM — so this stays a single scalar and every mm
           conversion downstream keeps working unchanged on a rectangular sheet. */
        function getPixelsPerMm(){ return els.rectifiedCanvas.width ? els.rectifiedCanvas.width / getTargetWidthMm() : RECTIFIED_PX_PER_MM; }
        /* Back-compat shims: square presets behave exactly as before. */
        function getReferenceSpacingMm(){ return getSpacingXMm(); }
        function getTargetSizeMm(){ return getTargetWidthMm(); }
        function getRectifiedSizePx(){ return getRectifiedWidthPx(); }

        /* Corners are TL,TR,BR,BL, so edges alternate horizontal, vertical,
           horizontal, vertical. On a RECTANGULAR grid the two axes have
           different mm lengths, so averaging all four side lengths against a
           single spacing (what this did before) skews px/mm badly — on TT7 the
           horizontal edge is 340mm and the vertical 240mm. Scale each axis by
           its own spacing first, then average the two ratios. Square presets
           are unaffected: sx == sy makes this identical to the old maths. */
        function getSourcePixelsPerMm(corners){
          const useCorners = corners || state.baseCorners || state.manualCorners;
          if (!useCorners || useCorners.length !== 4) return null;
          const sx = Math.max(getSpacingXMm(), 1);
          const sy = Math.max(getSpacingYMm(), 1);
          const hEdges = (distance(useCorners[0], useCorners[1]) + distance(useCorners[2], useCorners[3])) / 2;
          const vEdges = (distance(useCorners[1], useCorners[2]) + distance(useCorners[3], useCorners[0])) / 2;
          return (hEdges / sx + vEdges / sy) / 2;
        }

        function resetFineTuneOffsets(){
          state.fineTuneOffsetsMm = [
            { x: 0, y: 0 },
            { x: 0, y: 0 },
            { x: 0, y: 0 },
            { x: 0, y: 0 }
          ];
        }

        function syncCornerInputs(){
          els.cornerInputs.forEach((pair, index) => {
            const offset = state.fineTuneOffsetsMm[index] || { x: 0, y: 0 };
            pair.x.value = formatNumber(offset.x, 0);
            pair.y.value = formatNumber(offset.y, 0);
          });
        }

        function syncFineTuneOffsetsFromInputs(){
          state.fineTuneOffsetsMm = els.cornerInputs.map((pair) => {
            const x = Number(pair.x.value);
            const y = Number(pair.y.value);
            return {
              x: isFinite(x) ? x : 0,
              y: isFinite(y) ? y : 0
            };
          });
          syncCornerInputs();
        }

        function applyFineTuneAndProcess(skipDetection){
          if (!(state.baseCorners && state.baseCorners.length === 4)){
            if (!(state.manualCorners && state.manualCorners.length === 4)){
              setStatus('Detect or place all 4 reference markers before applying fine tune.');
              return;
            }
            state.baseCorners = state.manualCorners.map((p) => ({ x: p.x, y: p.y }));
          }
          syncFineTuneOffsetsFromInputs();
          const sourcePxPerMm = getSourcePixelsPerMm(state.baseCorners);
          if (!sourcePxPerMm || !isFinite(sourcePxPerMm)){
            setStatus('Could not calculate marker fine tune scale from the source photo.');
            return;
          }
          const nextCorners = state.baseCorners.map((corner, index) => {
            const offset = state.fineTuneOffsetsMm[index] || { x: 0, y: 0 };
            return {
              x: corner.x + (offset.x * sourcePxPerMm),
              y: corner.y + (offset.y * sourcePxPerMm)
            };
          });
          state.manualCorners = nextCorners.map((p) => ({ x: p.x, y: p.y }));
          state.corners = state.manualCorners.slice();
          state.placingManualMarkers = false;
          syncManualMarkerUI();
          drawSourcePreview(state.manualCorners);
          if (skipDetection) return;
          // V29: fine-tuning re-rectifies only -- shot detection is held
          // back until the user explicitly clicks Detect shots after
          // locking the source and entering the expected count.
          setStatus('Fine-tuned marker positions applied. Re-rectifying image…');
          renderFromCornersOnly(state.manualCorners.slice());
          // Already-detected shots become stale once geometry changes,
          // so wipe them and ask the user to re-run detection.
          if (state.shotsDetected || state.shots.length){
            state.shots = [];
            state.shotsDetected = false;
            state.coldBoreShotIndex = null;
            redrawRectifiedOverlay();
            updateMetrics();
          }
          syncWorkflowVisibility();
        }


        /* V60: Session schema version stamp. v=3 current; v=1/2 legacy. */
        var SESSION_SCHEMA_VERSION = 3;

        function serializeSession(){
          return {
            version: SESSION_SCHEMA_VERSION,
            savedAt: new Date().toISOString(),
            presetKey: state.presetKey,
            distanceM: getDistanceMetres(),
            // V24: thresholdOffset = \xB1 around Otsu auto. legacy
            // threshold:0 keeps older builds from misreading the value.
            thresholdOffset: Number(els.threshold.value || 0),
            threshold: 0,
            lockRectified: !!state.lockRectified,
            rectifiedZoom: Number(state.rectifiedZoom || 1),
            rectifiedPan: { x: Number(state.rectifiedPan.x || 0), y: Number(state.rectifiedPan.y || 0) },
            editMode: state.editMode,
            shots: state.shots.map((s) => ({ x: Number(s.x), y: Number(s.y) })),
            poiOffsetMm: { x: Number(state.poiOffsetMm.x || 0), y: Number(state.poiOffsetMm.y || 0) },
            baseCorners: state.baseCorners ? state.baseCorners.map((p) => ({ x: Number(p.x), y: Number(p.y) })) : null,
            manualCorners: state.manualCorners ? state.manualCorners.map((p) => ({ x: Number(p.x), y: Number(p.y) })) : null,
            corners: state.corners ? state.corners.map((p) => ({ x: Number(p.x), y: Number(p.y) })) : null,
            fineTuneOffsetsMm: state.fineTuneOffsetsMm.map((p) => ({ x: Number(p.x || 0), y: Number(p.y || 0) })),
            // V29: workflow + cold-bore state
            sourceLocked: !!state.sourceLocked,
            shotsDetected: !!state.shotsDetected,
            coldBoreShotIndex: state.coldBoreShotIndex,
            noColdBore: !!state.noColdBore,
            sourceImageDataUrl: state.lastSourceImageDataUrl || (els.sourceCanvas.width ? els.sourceCanvas.toDataURL('image/jpeg', 0.92) : ''),
          };
        }

        async function downloadSessionFile(){
          if (!els.sourceCanvas.width) {
            setStatus('Load a target photo before saving a session file.');
            return;
          }
          try {
            const payload = serializeSession();
            const jsonText = JSON.stringify(payload, null, 2);
            const stamp = new Date().toISOString().replace(/[:T]/g, '-').slice(0, 16);
            const fileName = `terra-impact-session-${stamp}.json`;

            if (window.isSecureContext && typeof window.showSaveFilePicker === 'function') {
              try {
                const handle = await window.showSaveFilePicker({
                  suggestedName: fileName,
                  id: 'terra-impact-session',
                  startIn: 'downloads',
                  types: [
                    {
                      description: 'JSON session file',
                      accept: { 'application/json': ['.json'] }
                    }
                  ]
                });
                const writable = await handle.createWritable();
                await writable.write(jsonText);
                await writable.close();
                setStatus('Terra-Impact session file saved to your chosen location.');
                return;
              } catch (pickerError) {
                if (pickerError && pickerError.name === 'AbortError') {
                  setStatus('Session save cancelled.');
                  return;
                }
                console.warn('Terra-Impact save picker failed, falling back to browser download.', pickerError);
              }
            }

            const blob = new Blob([jsonText], { type: 'application/json;charset=utf-8' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = fileName;
            link.style.display = 'none';
            link.setAttribute('target', '_blank');
            link.setAttribute('rel', 'noopener');
            document.body.appendChild(link);
            const clickEvent = new MouseEvent('click', { view: window, bubbles: true, cancelable: true });
            link.dispatchEvent(clickEvent);
            setTimeout(() => {
              if (link.parentNode) link.parentNode.removeChild(link);
              URL.revokeObjectURL(url);
            }, 1500);
            setStatus('Terra-Impact session file saved using your browser download settings.');
          } catch (error) {
            console.error('Terra-Impact save failed', error);
            setStatus('Could not save the session file on this device/browser.');
          }
        }

        /* V25-B: CSV export -- header + per-shot rows in rectified coords */
        function shotsToCsv(){
          const pxPerMm = getPixelsPerMm();
          if (!pxPerMm || !isFinite(pxPerMm)) return '';
          const canvas = els.rectifiedCanvas;
          if (!canvas.width || !canvas.height) return '';
          const aimX = canvas.width / 2;
          const aimY = canvas.height / 2;
          const lines = [];
          const preset = getPreset();
          const distM = getDistanceMetres();

          // Metadata rows (each starts with "#" so that spreadsheet imports
          // can be told to treat them as a comment or skip N lines).
          lines.push(`# Terra-Impact export — ${new Date().toISOString()}`);
          lines.push(`# preset,${preset.label} (${getSpacingXMm()} x ${getSpacingYMm()} mm spacing)`);
          lines.push(`# distance_m,${distM}`);
          lines.push(`# shots_counted,${state.shots.length}`);
          lines.push(`# poi_x_mm,${state.poiOffsetMm.x.toFixed(2)}`);
          lines.push(`# poi_y_mm,${state.poiOffsetMm.y.toFixed(2)}`);
          // Column header.
          lines.push('shot_number,x_mm,y_mm,dist_from_centre_mm,diameter_mm,major_mm,minor_mm,angle_deg');

          const fmt = (n, digits) => (isFinite(n) ? Number(n).toFixed(digits) : '');

          state.shots.forEach((s, i) => {
            const dxMm = (s.x - aimX) / pxPerMm;
            const dyMm = (s.y - aimY) / pxPerMm;
            const dist = Math.hypot(dxMm, dyMm);
            const majorMm = isFinite(s.majorDiam) ? s.majorDiam / pxPerMm : NaN;
            const minorMm = isFinite(s.minorDiam) ? s.minorDiam / pxPerMm : NaN;
            // Mean diameter is a better single-number summary than major
            // alone for slightly-elliptical holes.
            const meanMm = isFinite(majorMm) && isFinite(minorMm)
              ? (majorMm + minorMm) * 0.5
              : NaN;
            const angleDeg = isFinite(s.theta) ? (s.theta * 180 / Math.PI) : NaN;
            lines.push([
              i + 1,
              fmt(dxMm, 2),
              fmt(dyMm, 2),
              fmt(dist, 2),
              fmt(meanMm, 2),
              fmt(majorMm, 2),
              fmt(minorMm, 2),
              fmt(angleDeg, 1)
            ].join(','));
          });
          return lines.join('\n') + '\n';
        }

        function downloadShotsCsv(){
          if (!state.shots.length){
            setStatus('No shots to export. Detect or place shots first.');
            return;
          }
          const csv = shotsToCsv();
          if (!csv){
            setStatus('Could not build CSV — load a target photo and run detection first.');
            return;
          }
          try {
            const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            const stamp = new Date().toISOString().replace(/[:.]/g, '-').slice(0, 19);
            a.href = url;
            a.download = `terra-impact-shots-${stamp}.csv`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            setTimeout(() => URL.revokeObjectURL(url), 1000);
            setStatus(`Exported ${state.shots.length} shot${state.shots.length === 1 ? '' : 's'} to CSV.`);
          } catch (error){
            console.error('Terra-Impact CSV export failed', error);
            setStatus('Could not export CSV on this device/browser.');
          }
        }

        function saveBrowserSession(){
          if (!els.sourceCanvas.width) {
            setStatus('Load a target photo before saving in this browser.');
            return;
          }
          try {
            const payload = serializeSession();
            window.localStorage.setItem(BROWSER_SAVE_KEY, JSON.stringify(payload));
            setStatus('Terra-Impact session saved in this browser.');
          } catch (error) {
            console.error('Terra-Impact browser save failed', error);
            setStatus('Could not save in this browser.');
          }
        }

        function loadBrowserSession(){
          try {
            const raw = window.localStorage.getItem(BROWSER_SAVE_KEY);
            if (!raw) {
              setStatus('No browser save was found on this device.');
              return;
            }
            const payload = JSON.parse(raw);
            state.isRestoringBrowserSave = true;
            restoreSessionFromPayload(payload);
            setTimeout(() => { state.isRestoringBrowserSave = false; }, 300);
          } catch (error) {
            console.error('Terra-Impact browser load failed', error);
            state.isRestoringBrowserSave = false;
            setStatus('Could not load the browser save.');
          }
        }


        function saveBrowserSessionSilently(){
          if (!els.sourceCanvas.width) return;
          try {
            const payload = serializeSession();
            window.localStorage.setItem(BROWSER_SAVE_KEY, JSON.stringify(payload));
          } catch (error) {
            console.error('Terra-Impact browser autosave failed', error);
          }
        }

        function queueBrowserAutoSave(){
          if (state.isRestoringBrowserSave) return;
          if (state.autoSaveTimer) clearTimeout(state.autoSaveTimer);
          state.autoSaveTimer = setTimeout(() => {
            saveBrowserSessionSilently();
          }, 180);
        }

        function loadBrowserSessionOnInit(){
          try {
            const raw = window.localStorage.getItem(BROWSER_SAVE_KEY);
            if (!raw) return;
            const payload = JSON.parse(raw);
            state.isRestoringBrowserSave = true;
            restoreSessionFromPayload(payload);
            setTimeout(() => { state.isRestoringBrowserSave = false; }, 300);
          } catch (error) {
            console.error('Terra-Impact initial browser load failed', error);
            state.isRestoringBrowserSave = false;
          }
        }

        function restoreSessionFromPayload(payload){
          if (!payload || !payload.sourceImageDataUrl) {
            setStatus('That session file is missing the saved source photo.');
            return;
          }
          /* V60: schema version check; wipe stale saves */
          if (payload.version !== SESSION_SCHEMA_VERSION){
            if (typeof console !== 'undefined' && console.warn){
              console.warn(
                '[terra-impact] Discarding session payload: schema v=' +
                payload.version + ', expected v=' + SESSION_SCHEMA_VERSION
              );
            }
            try { window.localStorage.removeItem(BROWSER_SAVE_KEY); } catch(_){}
            setStatus('Saved session was from an older version of Terra-Impact and could not be restored.');
            return;
          }
          resetWorkingState();
          state.presetKey = PRESETS[payload.presetKey] ? payload.presetKey : 'impact-150';
          syncPresetUI();
          /* V65: payload.distanceM is metres; convert for display. */
          if (payload.distanceM){
            setDistanceFromMetres(Number(payload.distanceM));
          } else {
            els.distanceM.value = '';
          }
          // V24: read thresholdOffset; clamp to [-40,+40] so legacy
          // absolute-value payloads don\u2019t restore as a huge offset.
          let restoredOffset = 0;
          if (typeof payload.thresholdOffset === 'number'){
            restoredOffset = payload.thresholdOffset;
          }
          if (restoredOffset < -40 || restoredOffset > 40) restoredOffset = 0;
          els.threshold.value = restoredOffset;
          els.thresholdValue.textContent = (restoredOffset > 0 ? '+' : '') + String(restoredOffset);
          // V43 (a) / V58: the rectified-target lock state is now
          // preserved on browser autosave restore (coming back to the
          // page). For file-based session loads (someone else's saved
          // .terra file) we still force unlocked so the recipient
          // gets the full toolset on first open. The
          // isRestoringBrowserSave flag, set by the autosave restore
          // callers, distinguishes the two paths.
          state.lockRectified = state.isRestoringBrowserSave ? !!payload.lockRectified : false;
          state.fineTuneCollapsed = !!payload.fineTuneCollapsed;
          if (els.lockRectified) els.lockRectified.checked = state.lockRectified;
          state.rectifiedZoom = Number(payload.rectifiedZoom || 1);
          state.rectifiedPan = {
            x: Number(payload.rectifiedPan && payload.rectifiedPan.x || 0),
            y: Number(payload.rectifiedPan && payload.rectifiedPan.y || 0)
          };
          state.editMode = payload.editMode === 'remove' ? 'remove' : 'place';
          syncEditButton();
          syncLockRectifiedUI();
          const savedFineTune = Array.isArray(payload.fineTuneOffsetsMm) && payload.fineTuneOffsetsMm.length === 4 ? payload.fineTuneOffsetsMm : state.fineTuneOffsetsMm;
          state.fineTuneOffsetsMm = savedFineTune.map((p) => ({ x: Number(p && p.x || 0), y: Number(p && p.y || 0) }));
          syncCornerInputs();
          syncFineTuneCollapseUI();
          syncMeasurementLockUI();
          state.lastSourceImageDataUrl = payload.sourceImageDataUrl;

          const img = new Image();
          img.onload = () => {
            els.sourceCanvas.width = img.width;
            els.sourceCanvas.height = img.height;
            const ctx = els.sourceCanvas.getContext('2d', { willReadFrequently: true });
            ctx.clearRect(0, 0, img.width, img.height);
            ctx.drawImage(img, 0, 0);
            state.baseCorners = Array.isArray(payload.baseCorners) && payload.baseCorners.length === 4 ? payload.baseCorners.map((p) => ({ x: Number(p.x), y: Number(p.y) })) : null;
            state.manualCorners = Array.isArray(payload.manualCorners) && payload.manualCorners.length === 4 ? payload.manualCorners.map((p) => ({ x: Number(p.x), y: Number(p.y) })) : null;
            state.corners = Array.isArray(payload.corners) && payload.corners.length === 4 ? payload.corners.map((p) => ({ x: Number(p.x), y: Number(p.y) })) : (state.manualCorners ? state.manualCorners.slice() : null);
            drawSourcePreview(state.manualCorners && state.manualCorners.length === 4 ? state.manualCorners : state.corners);
            if (state.manualCorners && state.manualCorners.length === 4) {
              renderFromCornersOnly(state.manualCorners.slice());
            }
            state.shots = Array.isArray(payload.shots) ? payload.shots.map((s) => ({ x: Number(s.x), y: Number(s.y) })).filter((s) => isFinite(s.x) && isFinite(s.y)) : [];
            // V29: restore workflow flags. Older payloads (pre-V29) won't
            // have these fields \u2014 default to "fully open" if shots
            // were saved (since the user clearly progressed past the
            // staged reveal in the old version).
            if (typeof payload.sourceLocked === 'boolean'){
              state.sourceLocked = payload.sourceLocked;
            } else {
              state.sourceLocked = state.shots.length > 0;
            }
            if (typeof payload.shotsDetected === 'boolean'){
              state.shotsDetected = payload.shotsDetected;
            } else {
              state.shotsDetected = state.shots.length > 0;
            }
            state.coldBoreShotIndex = (typeof payload.coldBoreShotIndex === 'number'
              && payload.coldBoreShotIndex >= 0
              && payload.coldBoreShotIndex < state.shots.length) ? payload.coldBoreShotIndex : null;
            state.noColdBore = !!payload.noColdBore;
            redrawRectifiedOverlay();
            updateMetrics();
            syncLockRectifiedUI();
            syncMeasurementLockUI();
            applyNoColdBore();
            syncColdBoreUI();
            syncWorkflowVisibility();
            queueBrowserAutoSave();
            setStatus('Terra-Impact session restored from local file.');
          };
          img.src = payload.sourceImageDataUrl;
        }

        function loadSessionFromFile(file){
          if (!file) return;
          const reader = new FileReader();
          reader.onload = () => {
            try {
              const payload = JSON.parse(String(reader.result || '{}'));
              restoreSessionFromPayload(payload);
            } catch (error) {
              setStatus('Could not read that session file. Please load a valid Terra-Impact JSON session.');
            }
          };
          reader.readAsText(file);
        }

        function setStatus(text){ els.statusText.textContent = text; }

        function syncPresetUI(){
          const preset = getPreset();
          if (els.presetSelect && els.presetSelect.value !== state.presetKey){
            els.presetSelect.value = state.presetKey;
          }
        }

        function syncLockRectifiedUI(){
          if (els.lockRectified) els.lockRectified.checked = !!state.lockRectified;
          if (els.rectifiedCard) {
            els.rectifiedCard.classList.toggle('is-locked', !!state.lockRectified);
            els.rectifiedCard.classList.toggle('is-panning', !!state.isPanningRectified);
          }
          if (els.rectifiedWrap) {
            const isViewOnly = !!state.lockRectified || Number(state.rectifiedZoom || 1) > 1.001;
            els.rectifiedWrap.classList.toggle('is-view-only', isViewOnly);
            els.rectifiedWrap.classList.toggle('is-panning', !!state.isPanningRectified);
          }
          if (els.lockBadge) {
            els.lockBadge.setAttribute('aria-hidden', state.lockRectified ? 'false' : 'true');
          }
          if (els.lockHint) {
            els.lockHint.textContent = state.lockRectified
              ? 'Rectified target locked. Use mouse wheel or pinch to zoom, and drag to pan.'
              : 'Rectified target can still zoom at any time. Lock it when you want to freeze measurement controls and drag-pan safely.';
          }
          // V29: drive the lock pill below the rectified canvas.
          syncLockPill();
          // V30: shots card hides while the rectified canvas is locked.
          syncWorkflowVisibility();
          applyRectifiedViewport();
        }


        function syncMeasurementLockUI(){
          // V35: detectShotsBtn joins lock-disable list. V39 (d):
          // noColdBoreToggle joins; coldBoreBtn gated via syncColdBoreUI
          // to preserve no-shots / no-cold-bore states.
          const controls = [els.threshold, els.clearShotsBtn, els.editBtn,
                            els.addShotBtn, els.deleteShotBtn, els.detectShotsBtn,
                            els.noColdBoreToggle];
          controls.forEach((control) => {
            if (!control) return;
            control.disabled = !!state.lockRectified;
          });
          syncColdBoreUI();
        }

        function syncFineTuneCollapseUI(){
          if (els.fineTuneCard) els.fineTuneCard.classList.toggle('is-collapsed', !!state.fineTuneCollapsed);
          if (els.fineTuneToggleBtn) {
            els.fineTuneToggleBtn.textContent = state.fineTuneCollapsed ? 'Show fine tune' : 'Hide fine tune';
            els.fineTuneToggleBtn.setAttribute('aria-expanded', state.fineTuneCollapsed ? 'false' : 'true');
          }
        }

        // V27/V56: mirror of syncFineTuneCollapseUI for the Advanced
        // card. The toggle button is now a chevron pill (matches
        // Terra-Analyse): aria-expanded drives chevron rotation via
        // CSS; no inline text label to keep in sync.
        function syncAdvancedCollapseUI(){
          if (els.advancedCard) els.advancedCard.classList.toggle('is-collapsed', !!state.advancedCollapsed);
          if (els.advancedToggleBtn) {
            const expanded = !state.advancedCollapsed;
            els.advancedToggleBtn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
            els.advancedToggleBtn.setAttribute('aria-label', expanded ? 'Collapse section' : 'Expand section');
            els.advancedToggleBtn.setAttribute('title', expanded ? 'Collapse' : 'Expand');
          }
        }

        // V29: workflow visibility \u2014 progressively reveal cards as the
        // user moves through scan/load/lock/expected/detect stages.
        function syncWorkflowVisibility(){
          const hasPhoto = !!(els.sourceCanvas && els.sourceCanvas.width);
          const hasCorners = !!(state.baseCorners && state.baseCorners.length === 4);
          const hasRectified = !!state.rectifiedBaseImageData;
          const isLocked = !!state.sourceLocked;
          const hasShots = state.shotsDetected || state.shots.length > 0;
          const isRectifiedLocked = !!state.lockRectified;

          // V30: when the SOURCE is locked, hide setup cards 1\u20132 and the
          // source-photo preview entirely so the user gets a clean,
          // measurement-only view. They reappear if the user unlocks.
          if (els.presetCard) els.presetCard.classList.toggle('is-hidden', isLocked);
          if (els.loadCard) els.loadCard.classList.toggle('is-hidden', isLocked);
          if (els.sourceCard) els.sourceCard.classList.toggle('is-hidden', isLocked);

          // Lock-source decision card appears once corners are known.
          if (els.lockSourceCard) els.lockSourceCard.classList.toggle('is-hidden', !hasCorners);
          // Fine-tune is hidden when source is locked OR when corners aren't known yet.
          if (els.fineTuneCard) els.fineTuneCard.classList.toggle('is-hidden', !hasCorners || isLocked);
          // Rectified canvas only meaningful once rectification has happened.
          if (els.rectifiedCard) els.rectifiedCard.classList.toggle('is-hidden', !hasRectified);
          // Expected-shots / detect button only after lock. V41 (a):
          // also hide when the rectified target is locked, because in
          // measurement-only mode the user wants their attention on
          // the canvas + metrics, not on the detection controls.
          if (els.expectedCard) els.expectedCard.classList.toggle('is-hidden', !hasRectified || !isLocked || isRectifiedLocked);

          // V66: the "Send to Terra-Confirm" CTA appears once shots are detected
          // (the moment the user has a result worth keeping).
          if (els.saveToConfirmBtn) els.saveToConfirmBtn.hidden = !hasShots;

          // Lock-source button label / pressed state.
          // V58: button keeps the soft style in both states; label
          // text and aria-pressed convey "locked vs unlocked"
          // without the visual weight of the green primary CTA.
          if (els.lockSourceBtn){
            els.lockSourceBtn.textContent = isLocked ? 'Unlock source' : 'Lock source';
            els.lockSourceBtn.setAttribute('aria-pressed', isLocked ? 'true' : 'false');
          }
          if (els.lockSourceCard){
            els.lockSourceCard.classList.toggle('is-locked', isLocked);
          }
          if (els.lockSourceStatus){
            els.lockSourceStatus.textContent = isLocked
              ? 'Source corners locked. Enter expected shots and run detection below.'
              : 'Source not locked. Open fine-tune below if you need to adjust corners.';
          }
        }

        // V30: source lock toggle. V38 (f): on UNLOCK re-sync inputs +
        // redraw source preview so fine-tune offsets are visibly
        // restored.
        function setSourceLocked(nextLocked, opts){
          state.sourceLocked = !!nextLocked;
          if (state.sourceLocked){
            // Collapse the fine-tune card silently (without setting the
            // user-override flag) so re-unlocking restores the prior view.
            state.fineTuneCollapsed = true;
            syncFineTuneCollapseUI();
          } else {
            // V38 (f): bring the inputs and source preview back in
            // line with the saved fine-tune state.
            try { syncCornerInputs(); } catch(_){}
            if (state.manualCorners && state.manualCorners.length === 4){
              try { drawSourcePreview(state.manualCorners); } catch(_){}
            }
          }
          syncWorkflowVisibility();
          queueBrowserAutoSave();
          // V30: locking no longer auto-runs shot detection. The user
          // confirms expected shots and presses "Detect shots" themselves
          // so they can adjust the round count first.
          if (state.sourceLocked){
            setStatus('Source corners locked. Enter expected shots above the canvas, then tap Detect shots.');
          } else {
            setStatus('Source unlocked \u2014 setup cards re-revealed.');
          }
        }

        // V29: cold-bore tagging \u2014 toggle mode then tap a shot to flag.
        // V34: cold-bore is auto-assigned to the first detected shot.
        // The button cycles the cold-bore tag through subsequent shots
        // (1 \u2192 2 \u2192 ... \u2192 N \u2192 1 \u2026) so the user never has to tap a
        // specific shot on the canvas to retag.
        function syncColdBoreUI(){
          if (!els.coldBoreBtn) return;
          els.coldBoreBtn.removeAttribute('aria-pressed');
          // V39 (d): rectified lock disables the cold-bore controls so
          // the user can\u2019t change tagging while in measurement-only
          // mode.
          if (state.lockRectified){
            els.coldBoreBtn.disabled = true;
            return;
          }
          // V35: disable while "no cold bore" is on.
          if (state.noColdBore){
            els.coldBoreBtn.disabled = true;
            els.coldBoreBtn.textContent = 'Cold bore disabled';
            return;
          }
          // V40 (f): button enabled by default \u2014 even before shots are
          // detected. Clicking with 0 shots is handled in
          // cycleColdBoreShot() with a friendly status message.
          els.coldBoreBtn.disabled = false;
          const n = state.shots.length;
          if (n === 0){
            els.coldBoreBtn.textContent = 'Tag cold bore shot';
          } else if (state.coldBoreShotIndex == null){
            els.coldBoreBtn.textContent = `Tag cold bore shot (${n} ${n === 1 ? 'shot' : 'shots'})`;
          } else {
            els.coldBoreBtn.textContent = `Cold bore: shot ${state.coldBoreShotIndex + 1} of ${n} \u2014 re-tag`;
          }
        }

        // V34: ensure a sane cold-bore index whenever the shot set
        // changes. Auto-assign the first shot when there are shots and
        // none is currently tagged; clamp to range otherwise.
        // V35: bail out entirely when "No cold bore" is on.
        function ensureColdBoreDefault(){
          if (state.noColdBore){
            state.coldBoreShotIndex = null;
            return;
          }
          const n = state.shots.length;
          if (n === 0){
            state.coldBoreShotIndex = null;
            return;
          }
          if (state.coldBoreShotIndex == null
              || state.coldBoreShotIndex < 0
              || state.coldBoreShotIndex >= n){
            state.coldBoreShotIndex = 0;
          }
        }

        function cycleColdBoreShot(){
          if (state.noColdBore){
            setStatus('"No cold bore" is on. Untick it to tag a cold-bore shot.');
            return;
          }
          const n = state.shots.length;
          if (n === 0){
            setStatus('Detect or place a shot first, then tag the cold bore.');
            return;
          }
          if (state.coldBoreShotIndex == null){
            state.coldBoreShotIndex = 0;
          } else {
            state.coldBoreShotIndex = (state.coldBoreShotIndex + 1) % n;
          }
          syncColdBoreUI();
          syncEditButton();
          redrawRectifiedOverlay();
          updateMetrics();
          queueBrowserAutoSave();
          setStatus(`Cold bore re-tagged to shot #${state.coldBoreShotIndex + 1}.`);
        }

        // V35: drives every UI surface that depends on the no-cold-bore
        // toggle: root class (used by CSS to hide POI cards + dim button),
        // checkbox state, button label/state.
        function applyNoColdBore(){
          const enabled = !!state.noColdBore;
          root.classList.toggle('no-coldbore', enabled);
          if (els.noColdBoreToggle && els.noColdBoreToggle.checked !== enabled){
            els.noColdBoreToggle.checked = enabled;
          }
          if (enabled){
            state.coldBoreShotIndex = null;
          } else {
            ensureColdBoreDefault();
          }
          syncColdBoreUI();
          updateMetrics();
          redrawRectifiedOverlay();
        }

        // V29: lock pill -- freezes rectified canvas. V37: label class
        // renamed to .terra-shot-lock-label, text simplified to
        // "Locked" / "Unlocked".
        function syncLockPill(){
          if (!els.lockPill) return;
          const isLocked = !!state.lockRectified;
          els.lockPill.setAttribute('aria-pressed', isLocked ? 'true' : 'false');
          const labelEl = els.lockPill.querySelector('.terra-shot-lock-label');
          if (labelEl){
            labelEl.textContent = isLocked ? 'Locked' : 'Unlocked';
          }
        }

        // V32: preset preselection from URL query string. The QR
        // codes printed on Terra-Impact targets link to this page
        // with ?preset=TT1..TT5 (or impact-75..impact-180). Future
        // params: ?distance=, ?target= (informational).
        const PRESET_LABEL_TO_KEY = {
          'TT1': 'impact-75',
          'TT2': 'impact-100',
          'TT3': 'impact-120',
          'TT4': 'impact-150',
          'TT5': 'impact-180',
          'TT10': 'impact-370x247',
          'TT11': 'impact-247x160',
          'TT12': 'impact-247x370',
          'TT13': 'impact-160x247',
          'TT14': 'impact-381.8x229.4',
          'TT15': 'impact-229.4x165.9',
          'TT16': 'impact-229.4x381.8',
          'TT17': 'impact-165.9x229.4'
        };
        function applyUrlParams(){
          try {
            const params = new URLSearchParams(window.location.search);
            // V66: long-form ?preset= or QR short-form ?m=
            const preset = (params.get('preset') || params.get('m') || '').trim();
            if (preset){
              const upper = preset.toUpperCase();
              const key = PRESET_LABEL_TO_KEY[upper] || (PRESETS[preset] ? preset : null);
              if (key && PRESETS[key]){
                state.presetKey = key;
              }
            }
            // V66: ?distance= / ?distance_m= / ?d= (any numeric or "100yd")
            const rawDistance = params.get('distance') || params.get('distance_m') || params.get('d');
            if (rawDistance && els.distanceM){
              const metres = parseDistanceParam(rawDistance);
              if (isFinite(metres) && metres > 0){
                setDistanceFromMetres(metres);
                els.distanceM.classList.add('is-auto-filled');
              }
            }
          } catch(_){}
        }
        // V66: parse distance param to metres; numeric or unit-tagged.
        function parseDistanceParam(value){
          if (value == null) return NaN;
          const raw = String(value).trim().toLowerCase().replace(',', '.');
          const m = raw.match(/([0-9]+(?:\.[0-9]+)?)/);
          if (!m) return NaN;
          const amount = parseFloat(m[1]);
          if (!isFinite(amount) || amount <= 0) return NaN;
          if (raw.indexOf('yd') !== -1 || raw.indexOf('yard') !== -1) return amount * M_PER_YARD;
          if (raw.indexOf('km') !== -1) return amount * 1000;
          return amount;
        }

        function syncEditButton(){
          // V35: dual Add / Delete shot buttons. The active mode\u2019s button
          // is fully opaque + ring-highlighted; the inactive button dims.
          const isRemove = state.editMode === 'remove';
          if (els.addShotBtn){
            els.addShotBtn.classList.toggle('is-active', !isRemove);
            els.addShotBtn.setAttribute('aria-pressed', !isRemove ? 'true' : 'false');
          }
          if (els.deleteShotBtn){
            els.deleteShotBtn.classList.toggle('is-active', isRemove);
            els.deleteShotBtn.setAttribute('aria-pressed', isRemove ? 'true' : 'false');
          }
          // Legacy single-toggle button still gets updated if it exists
          // (so any out-of-tree theme override keeps working).
          if (els.editBtn){
            els.editBtn.textContent = isRemove ? 'Delete shot' : 'Add shot';
            els.editBtn.className = 'terra-btn ' + (isRemove ? 'terra-btn-red' : 'terra-btn-green');
          }
          const isZoomed = Number(state.rectifiedZoom || 1) > 1.001;
          const useGrab = state.lockRectified || state.isPanningRectified || isZoomed;
          // V55: also drive cursor via a wrap class so the full wrap
          // area (including padding/border + before the rectified canvas
          // is populated) shows the correct cursor. Inline cursor on
          // the canvas itself is kept for hover-over-canvas precision.
          if (els.rectifiedWrap){
            els.rectifiedWrap.classList.toggle('is-add-mode', !useGrab && state.editMode === 'place');
          }
          els.rectifiedCanvas.style.cursor = useGrab
            ? 'grab'
            : (state.editMode === 'place' ? 'crosshair' : 'default');
        }

        function clampRectifiedViewport(){
          const zoom = Math.max(1, Number(state.rectifiedZoom || 1));
          state.rectifiedZoom = zoom;
          if (zoom <= 1.001) {
            state.rectifiedPan = { x: 0, y: 0 };
            return;
          }
          const canvas = els.rectifiedCanvas;
          const maxX = ((zoom - 1) * canvas.width) / 2;
          const maxY = ((zoom - 1) * canvas.height) / 2;
          state.rectifiedPan.x = Math.max(-maxX, Math.min(maxX, Number(state.rectifiedPan.x || 0)));
          state.rectifiedPan.y = Math.max(-maxY, Math.min(maxY, Number(state.rectifiedPan.y || 0)));
        }

        function applyRectifiedViewport(){
          if (!els.rectifiedCanvas) return;
          clampRectifiedViewport();
          const zoom = Number(state.rectifiedZoom || 1);
          const panX = Number(state.rectifiedPan.x || 0);
          const panY = Number(state.rectifiedPan.y || 0);
          els.rectifiedCanvas.style.transform = `translate(${panX}px, ${panY}px) scale(${zoom})`;
        }

        function resetRectifiedViewport(){
          state.rectifiedZoom = 1;
          state.rectifiedPan = { x: 0, y: 0 };
          applyRectifiedViewport();
        }

        function setLockRectified(nextLocked){
          state.lockRectified = !!nextLocked;
          state.isPanningRectified = false;
          state.lastPanPoint = null;
          state.pinchDistance = 0;
          if (!state.lockRectified) resetRectifiedViewport();
          syncEditButton();
          syncLockRectifiedUI();
          syncMeasurementLockUI();
          // V41 (a): refresh workflow visibility so frame 5 (Expected
          // shots & detection) hides while the rectified is locked
          // and reappears on unlock.
          syncWorkflowVisibility();
          // V41 (a): on lock, scroll the rectified card into view so
          // the user\u2019s focus stays on the canvas + metrics rather
          // than the now-hidden setup cards above.
          if (state.lockRectified && els.rectifiedCard
              && typeof els.rectifiedCard.scrollIntoView === 'function'){
            try {
              els.rectifiedCard.scrollIntoView({ behavior: 'smooth', block: 'start' });
            } catch(_){
              els.rectifiedCard.scrollIntoView();
            }
          }
          queueBrowserAutoSave();
        }

        function syncManualMarkerUI(){
          els.previewCanvas.style.cursor = 'default';
        }

        let rerunFeedbackTimer = null;
        function setRerunButtonState(mode){
          if (rerunFeedbackTimer) {
            clearTimeout(rerunFeedbackTimer);
            rerunFeedbackTimer = null;
          }
          // V30: rerun button removed from UI \u2014 keep the function so
          // existing call sites still work, but no-op when the button
          // isn\u2019t in the DOM.
          if (!els.rerunBtn) return;
          els.rerunBtn.classList.remove('terra-btn-running','terra-btn-complete');
          if (mode === 'running') {
            els.rerunBtn.classList.add('terra-btn-running');
            els.rerunBtn.textContent = 'Detecting…';
            els.rerunBtn.disabled = true;
          } else if (mode === 'complete') {
            els.rerunBtn.classList.add('terra-btn-complete');
            els.rerunBtn.textContent = 'Detection complete';
            els.rerunBtn.disabled = false;
            rerunFeedbackTimer = setTimeout(() => {
              els.rerunBtn.classList.remove('terra-btn-complete');
              els.rerunBtn.textContent = 'Re-run shot detection';
            }, 1200);
          } else {
            els.rerunBtn.textContent = 'Re-run shot detection';
            els.rerunBtn.disabled = false;
          }
        }

        function formatNumber(n, digits = 1){
          if (!isFinite(n)) return '-';
          return n.toFixed(digits).replace(/\.0$/, '');
        }

        /* V65: unit system. Internal state metric; UI converts at display. */
        const UNIT_SYSTEM_KEY = 'terra-unit-system';
        const MM_PER_INCH = 25.4;
        const M_PER_YARD = 0.9144;
        function readStoredUnitSystem(){
          try { const v = localStorage.getItem(UNIT_SYSTEM_KEY); return (v === 'imperial' || v === 'metric') ? v : null; } catch(_){ return null; }
        }
        function writeStoredUnitSystem(units){
          try { localStorage.setItem(UNIT_SYSTEM_KEY, units); } catch(_){}
        }
        function formatLength(mm){
          if (!isFinite(mm)) return '-';
          if (state.unitSystem === 'imperial') return formatNumber(mm / MM_PER_INCH, 2) + ' in';
          return formatNumber(mm, 1) + ' mm';
        }
        function formatPoiOffset(mm, axis){
          if (!isFinite(mm)) return '-';
          const zeroThreshold = state.unitSystem === 'imperial' ? 0.005 * MM_PER_INCH : 0.05;
          if (Math.abs(mm) < zeroThreshold) return state.unitSystem === 'imperial' ? '0 in' : '0 mm';
          let suffix = '';
          if (axis === 'x') suffix = mm > 0 ? ' RIGHT' : ' LEFT';
          else if (axis === 'y') suffix = mm > 0 ? ' LOW' : ' HIGH';
          return formatLength(Math.abs(mm)) + suffix;
        }
        function getDistanceMetres(){
          const v = Number(els.distanceM && els.distanceM.value || 0);
          if (!isFinite(v) || v <= 0) return 0;
          return state.unitSystem === 'imperial' ? v * M_PER_YARD : v;
        }
        function setDistanceFromMetres(metres){
          if (!els.distanceM) return;
          if (!isFinite(metres) || metres <= 0){ els.distanceM.value = ''; return; }
          const display = state.unitSystem === 'imperial' ? metres / M_PER_YARD : metres;
          els.distanceM.value = String(Math.round(display));
        }
        function applyUnitSystem(units, opts){
          const next = (units === 'imperial') ? 'imperial' : 'metric';
          const distanceMetres = getDistanceMetres();
          state.unitSystem = next;
          if (!opts || opts.save !== false) writeStoredUnitSystem(next);
          root.querySelectorAll('.terra-unit-segment[data-unit-system]').forEach(function(btn){
            const isActive = btn.getAttribute('data-unit-system') === next;
            btn.classList.toggle('is-active', isActive);
            btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
          });
          const labelEl = document.getElementById('distanceLabel-' + sectionId);
          if (labelEl) labelEl.textContent = 'Distance to target (' + (next === 'imperial' ? 'yd' : 'm') + ')';
          if (distanceMetres > 0) setDistanceFromMetres(distanceMetres);
          if (typeof updateMetrics === 'function') updateMetrics();
        }

        function distance(a,b){ return Math.hypot(a.x-b.x, a.y-b.y); }

        function centroid(points){
          const sum = points.reduce((acc,p)=>({x:acc.x+p.x,y:acc.y+p.y}),{x:0,y:0});
          return {x:sum.x/points.length, y:sum.y/points.length};
        }

        function circleFromTwoPoints(a,b){
          return { x:(a.x+b.x)/2, y:(a.y+b.y)/2, r:Math.hypot(a.x-b.x,a.y-b.y)/2 };
        }

        function circleFromThreePoints(a,b,c){
          const d = 2 * (a.x*(b.y-c.y) + b.x*(c.y-a.y) + c.x*(a.y-b.y));
          if (Math.abs(d) < 1e-9) return null;
          const a2 = a.x*a.x + a.y*a.y;
          const b2 = b.x*b.x + b.y*b.y;
          const c2 = c.x*c.x + c.y*c.y;
          const ux = (a2*(b.y-c.y) + b2*(c.y-a.y) + c2*(a.y-b.y)) / d;
          const uy = (a2*(c.x-b.x) + b2*(a.x-c.x) + c2*(b.x-a.x)) / d;
          return { x:ux, y:uy, r:Math.hypot(ux-a.x, uy-a.y) };
        }

        function containsAllPoints(circle, points, epsilon = 0.75){
          return points.every((p) => Math.hypot(p.x-circle.x, p.y-circle.y) <= circle.r + epsilon);
        }

        function largestSpreadCircle(points){
          if (!points || points.length < 2) return null;
          let a = points[0], b = points[1], maxD = -1;
          for (let i=0;i<points.length;i++){
            for (let j=i+1;j<points.length;j++){
              const d = Math.hypot(points[i].x-points[j].x, points[i].y-points[j].y);
              if (d > maxD) { maxD = d; a = points[i]; b = points[j]; }
            }
          }
          let best = null;
          const diameterCircle = circleFromTwoPoints(a,b);
          if (containsAllPoints(diameterCircle, points)) best = diameterCircle;
          for (const c of points){
            if (c === a || c === b) continue;
            const candidate = circleFromThreePoints(a,b,c);
            if (!candidate) continue;
            if (!containsAllPoints(candidate, points)) continue;
            if (!best || candidate.r < best.r) best = candidate;
          }
          if (!best){
            const mid = circleFromTwoPoints(a,b);
            let required = mid.r;
            for (const p of points) required = Math.max(required, Math.hypot(p.x-mid.x, p.y-mid.y));
            best = { x:mid.x, y:mid.y, r:required };
          }
          return { ...best, a, b };
        }

        function solveLinearSystem8(A,b){
          const M = A.map((row,i)=>[...row,b[i]]);
          const n = 8;
          for (let col=0; col<n; col++){
            let pivot = col;
            for (let r=col+1; r<n; r++) if (Math.abs(M[r][col]) > Math.abs(M[pivot][col])) pivot = r;
            if (Math.abs(M[pivot][col]) < 1e-10) return null;
            [M[col], M[pivot]] = [M[pivot], M[col]];
            const div = M[col][col];
            for (let c=col; c<=n; c++) M[col][c] /= div;
            for (let r=0; r<n; r++){
              if (r === col) continue;
              const factor = M[r][col];
              for (let c=col; c<=n; c++) M[r][c] -= factor * M[col][c];
            }
          }
          return M.map((row)=>row[n]);
        }

        function computeHomography(src,dst){
          const A = [], b = [];
          for (let i=0;i<4;i++){
            const {x,y} = src[i];
            const {x:u,y:v} = dst[i];
            A.push([x,y,1,0,0,0,-u*x,-u*y]); b.push(u);
            A.push([0,0,0,x,y,1,-v*x,-v*y]); b.push(v);
          }
          const h = solveLinearSystem8(A,b);
          if (!h) return null;
          return [[h[0],h[1],h[2]],[h[3],h[4],h[5]],[h[6],h[7],1]];
        }

        function applyHomography(H,x,y){
          const denom = H[2][0]*x + H[2][1]*y + H[2][2];
          if (Math.abs(denom) < 1e-9) return null;
          return {
            x:(H[0][0]*x + H[0][1]*y + H[0][2]) / denom,
            y:(H[1][0]*x + H[1][1]*y + H[1][2]) / denom
          };
        }

        function invert3x3(m){
          const [a,b,c] = m[0], [d,e,f] = m[1], [g,h,i] = m[2];
          const A = e*i - f*h, B = -(d*i - f*g), C = d*h - e*g;
          const D = -(b*i - c*h), E = a*i - c*g, F = -(a*h - b*g);
          const G = b*f - c*e, H = -(a*f - c*d), I = a*e - b*d;
          const det = a*A + b*B + c*C;
          if (Math.abs(det) < 1e-10) return null;
          return [[A/det, D/det, G/det],[B/det, E/det, H/det],[C/det, F/det, I/det]];
        }

        function drawRectifiedImage(sourceCanvas, corners){
          const targetWMm = getTargetWidthMm();
          const targetHMm = getTargetHeightMm();
          const marginMm = getReferenceMarginMm();
          const outWidth = getRectifiedWidthPx();
          const outHeight = getRectifiedHeightPx();
          const marginPxX = (marginMm / targetWMm) * outWidth;
          const marginPxY = (marginMm / targetHMm) * outHeight;
          const dst = [
            {x:marginPxX,y:marginPxY},
            {x:outWidth - marginPxX,y:marginPxY},
            {x:outWidth - marginPxX,y:outHeight - marginPxY},
            {x:marginPxX,y:outHeight - marginPxY}
          ];
          const H = computeHomography(corners, dst);
          const Hinv = H && invert3x3(H);
          if (!Hinv) return null;

          const srcCtx = sourceCanvas.getContext('2d', { willReadFrequently: true });
          const srcData = srcCtx.getImageData(0,0,sourceCanvas.width,sourceCanvas.height);
          const outCanvas = document.createElement('canvas');
          outCanvas.width = outWidth; outCanvas.height = outHeight;
          const outCtx = outCanvas.getContext('2d', { willReadFrequently: true });
          const outImage = outCtx.createImageData(outWidth, outHeight);

          for (let y=0; y<outHeight; y++){
            for (let x=0; x<outWidth; x++){
              const src = applyHomography(Hinv, x, y);
              const idxOut = (y*outWidth + x) * 4;
              if (!src) continue;
              const sx = Math.round(src.x), sy = Math.round(src.y);
              if (sx >= 0 && sx < sourceCanvas.width && sy >= 0 && sy < sourceCanvas.height){
                const idxIn = (sy*sourceCanvas.width + sx) * 4;
                outImage.data[idxOut] = srcData.data[idxIn];
                outImage.data[idxOut+1] = srcData.data[idxIn+1];
                outImage.data[idxOut+2] = srcData.data[idxIn+2];
                outImage.data[idxOut+3] = 255;
              } else {
                outImage.data[idxOut] = 245;
                outImage.data[idxOut+1] = 247;
                outImage.data[idxOut+2] = 244;
                outImage.data[idxOut+3] = 255;
              }
            }
          }
          outCtx.putImageData(outImage,0,0);
          return outCanvas;
        }

        function toGrayscale(imageData){
          const {data, width, height} = imageData;
          const gray = new Uint8ClampedArray(width*height);
          for (let i=0; i<width*height; i++){
            const idx = i*4;
            gray[i] = Math.round(data[idx]*0.299 + data[idx+1]*0.587 + data[idx+2]*0.114);
          }
          return gray;
        }


        function averageGrayRect(gray, width, height, x1, y1, x2, y2){
          x1 = Math.max(0, Math.floor(x1));
          y1 = Math.max(0, Math.floor(y1));
          x2 = Math.min(width - 1, Math.floor(x2));
          y2 = Math.min(height - 1, Math.floor(y2));
          if (x2 < x1 || y2 < y1) return 255;
          let sum = 0;
          let count = 0;
          for (let y = y1; y <= y2; y++){
            let row = y * width;
            for (let x = x1; x <= x2; x++){
              sum += gray[row + x];
              count++;
            }
          }
          return count ? (sum / count) : 255;
        }

        /* V23 image analysis helpers \u2014 integral image (O(1) rect-mean
           queries) + separable Gaussian blur shared by marker / shot
           detection. */

        // Summed-area table. Uses Float64Array for headroom so a single
        // summed cell never overflows even on large, bright images.
        function buildIntegralImage(gray, width, height){
          const stride = width + 1;
          const data = new Float64Array(stride * (height + 1));
          for (let y = 0; y < height; y++){
            const iiRow = (y + 1) * stride;
            const iiPrev = y * stride;
            const grayRow = y * width;
            let rowSum = 0;
            for (let x = 0; x < width; x++){
              rowSum += gray[grayRow + x];
              data[iiRow + x + 1] = data[iiPrev + x + 1] + rowSum;
            }
          }
          return { data: data, stride: stride, width: width, height: height };
        }

        // Mean gray value of the inclusive rectangle [x1,y1]-[x2,y2].
        // Returns 255 for empty or inverted rectangles so they don't
        // falsely pass a "dark" check.
        function integralRectMean(ii, x1, y1, x2, y2){
          x1 = Math.max(0, Math.floor(x1));
          y1 = Math.max(0, Math.floor(y1));
          x2 = Math.min(ii.width - 1, Math.floor(x2));
          y2 = Math.min(ii.height - 1, Math.floor(y2));
          if (x2 < x1 || y2 < y1) return 255;
          const s = ii.stride;
          const sum = ii.data[(y2 + 1) * s + (x2 + 1)]
                    - ii.data[y1       * s + (x2 + 1)]
                    - ii.data[(y2 + 1) * s +  x1]
                    + ii.data[y1       * s +  x1];
          return sum / ((x2 - x1 + 1) * (y2 - y1 + 1));
        }

        // Separable 3-tap Gaussian approximation (kernel [1,2,1]/4).
        // Suppresses paper-grain noise before binary thresholding
        // without measurably softening real hole edges.
        function gaussianBlur3x3(src, width, height){
          const tmp = new Uint8ClampedArray(width * height);
          for (let y = 0; y < height; y++){
            const row = y * width;
            for (let x = 0; x < width; x++){
              const xm = x > 0 ? x - 1 : x;
              const xp = x < width - 1 ? x + 1 : x;
              tmp[row + x] = (src[row + xm] + (src[row + x] << 1) + src[row + xp] + 2) >> 2;
            }
          }
          const out = new Uint8ClampedArray(width * height);
          for (let y = 0; y < height; y++){
            const ym = y > 0 ? y - 1 : y;
            const yp = y < height - 1 ? y + 1 : y;
            const rowOut = y * width;
            const rowM = ym * width;
            const rowC = y * width;
            const rowP = yp * width;
            for (let x = 0; x < width; x++){
              out[rowOut + x] = (tmp[rowM + x] + (tmp[rowC + x] << 1) + tmp[rowP + x] + 2) >> 2;
            }
          }
          return out;
        }

        // V24: Otsu between-class-variance threshold; clamped to
        // [45,160] to reject unimodal histograms.
        function computeOtsuThreshold(gray){
          const hist = new Uint32Array(256);
          const total = gray.length;
          if (total === 0) return 92;
          for (let i = 0; i < total; i++) hist[gray[i]]++;
          let sum = 0;
          for (let i = 0; i < 256; i++) sum += i * hist[i];
          let sumB = 0;
          let wB = 0;
          let maxVar = -1;
          let bestT = 92;
          for (let t = 0; t < 256; t++){
            wB += hist[t];
            if (wB === 0) continue;
            const wF = total - wB;
            if (wF === 0) break;
            sumB += t * hist[t];
            const mB = sumB / wB;
            const mF = (sum - sumB) / wF;
            const diff = mB - mF;
            const varBetween = wB * wF * diff * diff;
            if (varBetween > maxVar){ maxVar = varBetween; bestT = t; }
          }
          if (bestT < 45) bestT = 45;
          if (bestT > 160) bestT = 160;
          return bestT;
        }

        /* V23 corner marker detection -- sub-pixel centroid + geometry check */
        function detectCornerMarkers(canvas){
          const ctx = canvas.getContext('2d', { willReadFrequently: true });
          const {width, height} = canvas;
          const img = ctx.getImageData(0, 0, width, height);
          const gray = toGrayscale(img);
          const ii = buildIntegralImage(gray, width, height);

          const regionW = Math.max(140, Math.round(width * 0.38));
          const regionH = Math.max(140, Math.round(height * 0.38));
          const minDim = Math.min(width, height);
          const step = Math.max(2, Math.round(minDim / 260));
          const SCORE_ACCEPT = 0.30;

          // Aim-facing (inner) quadrant of the marker body per corner type.
          // tl sits top-left of image -> aim is bottom-right of marker, so 'br'
          // tr sits top-right -> aim is bottom-left,                      'bl'
          // br sits bottom-right -> aim is top-left,                      'tl'
          // bl sits bottom-left -> aim is top-right,                      'tr'
          const INNER_QUAD = { tl: 'br', tr: 'bl', br: 'tl', bl: 'tr' };

          function scoreMarker(type, cx, cy, s){
            // Body: s-radius square around (cx, cy).
            // Outer: 1.6s-radius square around (cx, cy); ring = outer − body.
            const body = integralRectMean(ii, cx - s, cy - s, cx + s, cy + s);
            const outer = integralRectMean(ii, cx - 1.6 * s, cy - 1.6 * s, cx + 1.6 * s, cy + 1.6 * s);
            const sFloor = Math.floor(s);
            const oFloor = Math.floor(1.6 * s);
            const bodyArea = (2 * sFloor + 1) * (2 * sFloor + 1);
            const outerArea = (2 * oFloor + 1) * (2 * oFloor + 1);
            const ringArea = Math.max(1, outerArea - bodyArea);
            const ring = (outer * outerArea - body * bodyArea) / ringArea;

            // Early exit: marker body must be clearly darker than its paper
            // surround. 22 gray-levels ≈ 8.6% of full scale -- comfortably
            // above sensor noise but well below real black-on-white contrast.
            const contrast = ring - body;
            if (contrast < 22) return -Infinity;

            // Four quadrants of the marker body.
            const qTL = integralRectMean(ii, cx - s, cy - s, cx - 1, cy - 1);
            const qTR = integralRectMean(ii, cx + 1, cy - s, cx + s, cy - 1);
            const qBR = integralRectMean(ii, cx + 1, cy + 1, cx + s, cy + s);
            const qBL = integralRectMean(ii, cx - s, cy + 1, cx - 1, cy + s);
            const quads = { tl: qTL, tr: qTR, br: qBR, bl: qBL };

            const innerKey = INNER_QUAD[type];
            const innerVal = quads[innerKey];
            let otherSum = 0;
            let otherMax = -Infinity;
            const keys = ['tl','tr','br','bl'];
            for (let k = 0; k < 4; k++){
              if (keys[k] === innerKey) continue;
              otherSum += quads[keys[k]];
              if (quads[keys[k]] > otherMax) otherMax = quads[keys[k]];
            }
            const otherMean = otherSum / 3;
            const innerBright = innerVal - otherMean;   // mean-relative
            const innerDominant = innerVal - otherMax;  // strict (≥ all others)

            // Combined normalized score. All terms are dimensionless in ~[0,1],
            // so the cut-off is lighting-invariant.
            return (contrast / 255) * 1.0
                 + Math.max(0, innerBright / 255) * 1.6
                 + (innerDominant > 4 ? 0.25 : 0);
          }

          // Always returns { x, y, s, score } -- never null. Callers
          // inspect the score to decide whether to treat the candidate as
          // a real match. This lets V24 surface confidence for every
          // corner, including the ones that failed acceptance.
          function searchCorner(type){
            const xStart = (type === 'tl' || type === 'bl') ? 0 : width - regionW;
            const xEnd   = (type === 'tl' || type === 'bl') ? regionW : width;
            const yStart = (type === 'tl' || type === 'tr') ? 0 : height - regionH;
            const yEnd   = (type === 'tl' || type === 'tr') ? regionH : height;

            // Expected marker half-size range: ≈ 2.2% - 9.5% of the shorter
            // image dimension. Covers typical phone shots from ~1 m to ~5 m.
            const minS = Math.max(10, Math.round(minDim * 0.022));
            const maxS = Math.round(minDim * 0.095);
            const scaleStep = Math.max(1, Math.round((maxS - minS) / 9));

            let best = { score: -Infinity, x: (xStart + xEnd) / 2, y: (yStart + yEnd) / 2, s: (minS + maxS) / 2 };

            // Coarse search across (scale, y, x).
            for (let s = minS; s <= maxS; s += scaleStep){
              const pad = Math.round(1.75 * s);
              for (let y = yStart + pad; y < yEnd - pad; y += step){
                for (let x = xStart + pad; x < xEnd - pad; x += step){
                  const score = scoreMarker(type, x, y, s);
                  if (score > best.score) { best = { score, x, y, s }; }
                }
              }
            }
            if (!isFinite(best.score) || best.score <= 0) return best;

            // Fine refinement: ±step pixels, ±18% scale, single-pixel stride.
            const scaleRange = Math.max(1, Math.round(best.s * 0.18));
            for (let s = Math.max(minS, best.s - scaleRange); s <= best.s + scaleRange; s++){
              const padS = Math.round(1.75 * s);
              const sxMin = Math.max(xStart + padS, best.x - step);
              const sxMax = Math.min(xEnd - padS, best.x + step);
              const syMin = Math.max(yStart + padS, best.y - step);
              const syMax = Math.min(yEnd - padS, best.y + step);
              for (let y = syMin; y <= syMax; y++){
                for (let x = sxMin; x <= sxMax; x++){
                  const score = scoreMarker(type, x, y, s);
                  if (score > best.score) { best = { score, x, y, s }; }
                }
              }
            }

            // V25: Sub-pixel centroid refinement via connected-component
            // BOUNDING BOX, not darkness-weighted centroid. The marker's
            // white aim circle sits in one quadrant of the dark body, so
            // a darkness-weighted mean pulls the centre AWAY from the
            // aim corner -- visible in field tests as the detection
            // crosshair sitting on the white circle rather than at the
            // geometric centre of the 20 mm square.
            // The bounding-box approach is immune to interior holes: we
            // find the tightest box around the connected dark region
            // containing the coarse detection and take its midpoint.
            if (best.score > SCORE_ACCEPT){
              const r = Math.max(4, Math.round(best.s * 1.2));
              const bx = Math.round(best.x);
              const by = Math.round(best.y);
              const x0 = Math.max(0, bx - r);
              const x1 = Math.min(width - 1, bx + r);
              const y0 = Math.max(0, by - r);
              const y1 = Math.min(height - 1, by + r);
              const bodyMean = integralRectMean(ii,
                Math.max(0, bx - Math.round(best.s * 0.9)),
                Math.max(0, by - Math.round(best.s * 0.9)),
                Math.min(width - 1, bx + Math.round(best.s * 0.9)),
                Math.min(height - 1, by + Math.round(best.s * 0.9)));
              const outerR = Math.round(best.s * 1.6);
              const outerMean = integralRectMean(ii,
                Math.max(0, bx - outerR), Math.max(0, by - outerR),
                Math.min(width - 1, bx + outerR), Math.min(height - 1, by + outerR));
              const darkCutoff = (bodyMean + outerMean) * 0.5;

              // Flood-fill the dark component reachable from (bx, by).
              // If (bx, by) itself is bright (the coarse centre landed
              // on the white aim circle), walk outward in a small spiral
              // to find the nearest dark seed pixel.
              const winW = x1 - x0 + 1;
              const winH = y1 - y0 + 1;
              const visited = new Uint8Array(winW * winH);
              function grayAt(px, py){ return gray[py * width + px]; }

              let seedX = bx, seedY = by;
              if (grayAt(seedX, seedY) >= darkCutoff){
                // Spiral search up to radius ≈ 0.9*s for a dark pixel.
                const spiralR = Math.max(3, Math.round(best.s * 0.9));
                let found = false;
                for (let rad = 1; rad <= spiralR && !found; rad++){
                  for (let dy = -rad; dy <= rad && !found; dy++){
                    for (let dx = -rad; dx <= rad && !found; dx++){
                      if (Math.abs(dx) !== rad && Math.abs(dy) !== rad) continue;
                      const px = bx + dx, py = by + dy;
                      if (px < x0 || px > x1 || py < y0 || py > y1) continue;
                      if (grayAt(px, py) < darkCutoff){
                        seedX = px; seedY = py; found = true;
                      }
                    }
                  }
                }
                if (!found){ return best; }  // No dark region found -- skip refinement.
              }

              // Iterative 4-neighbour flood fill within the window.
              const stack = [[seedX, seedY]];
              let bbMinX = seedX, bbMaxX = seedX, bbMinY = seedY, bbMaxY = seedY;
              let componentSize = 0;
              const maxComponent = winW * winH;
              while (stack.length){
                const [px, py] = stack.pop();
                if (px < x0 || px > x1 || py < y0 || py > y1) continue;
                const idx = (py - y0) * winW + (px - x0);
                if (visited[idx]) continue;
                if (grayAt(px, py) >= darkCutoff) continue;
                visited[idx] = 1;
                componentSize++;
                if (componentSize > maxComponent) break;
                if (px < bbMinX) bbMinX = px;
                if (px > bbMaxX) bbMaxX = px;
                if (py < bbMinY) bbMinY = py;
                if (py > bbMaxY) bbMaxY = py;
                stack.push([px + 1, py]);
                stack.push([px - 1, py]);
                stack.push([px, py + 1]);
                stack.push([px, py - 1]);
              }

              // Sanity-check the bounding box against the coarse scale
              // estimate. If the flood fill escaped the marker (bled
              // into a neighbouring dark region), fall back to (bx, by).
              const bbW = bbMaxX - bbMinX + 1;
              const bbH = bbMaxY - bbMinY + 1;
              const expectedSize = best.s * 2;
              const sizeOk = bbW >= expectedSize * 0.45
                          && bbW <= expectedSize * 1.60
                          && bbH >= expectedSize * 0.45
                          && bbH <= expectedSize * 1.60;
              if (sizeOk){
                best.x = (bbMinX + bbMaxX) * 0.5;
                best.y = (bbMinY + bbMaxY) * 0.5;
                // Refine scale estimate as well so rectification pads
                // the right amount for small / large markers.
                best.s = 0.5 * (bbW + bbH) * 0.5;  // half of mean side
              }
            }

            return best;
          }

          function validateGeometry(corners){
            if (!corners || corners.length !== 4) return false;
            const top = distance(corners[0], corners[1]);
            const right = distance(corners[1], corners[2]);
            const bottom = distance(corners[2], corners[3]);
            const left = distance(corners[3], corners[0]);
            const diagA = distance(corners[0], corners[2]);
            const diagB = distance(corners[1], corners[3]);
            const avgSide = (top + right + bottom + left) / 4;
            if (!isFinite(avgSide) || avgSide < Math.min(width, height) * 0.14) return false;
            if (Math.abs(top - bottom) > avgSide * 0.34) return false;
            if (Math.abs(left - right) > avgSide * 0.34) return false;
            if (Math.abs(diagA - diagB) > avgSide * 0.38) return false;

            // Shoelace area. For a valid quadrilateral this should be
            // close to avgSide² (exactly equal for a square). Reject if
            // the quad is less than ~55% of that -- indicates a flat
            // / near-collinear detection that the ratio tests missed.
            const ax = corners[0].x, ay = corners[0].y;
            const bx = corners[1].x, by = corners[1].y;
            const cx2 = corners[2].x, cy2 = corners[2].y;
            const dx2 = corners[3].x, dy2 = corners[3].y;
            const area = Math.abs(
              (ax * (by - dy2) + bx * (cy2 - ay) + cx2 * (dy2 - by) + dx2 * (ay - cy2)) * 0.5
            );
            if (area < avgSide * avgSide * 0.55) return false;
            return true;
          }

          const tl = searchCorner('tl');
          const tr = searchCorner('tr');
          const br = searchCorner('br');
          const bl = searchCorner('bl');

          const scores = {
            tl: isFinite(tl.score) ? Math.max(0, tl.score) : 0,
            tr: isFinite(tr.score) ? Math.max(0, tr.score) : 0,
            br: isFinite(br.score) ? Math.max(0, br.score) : 0,
            bl: isFinite(bl.score) ? Math.max(0, bl.score) : 0
          };
          const found = {
            tl: scores.tl > SCORE_ACCEPT,
            tr: scores.tr > SCORE_ACCEPT,
            br: scores.br > SCORE_ACCEPT,
            bl: scores.bl > SCORE_ACCEPT
          };

          const raw = { tl: tl, tr: tr, br: br, bl: bl };
          let corners = null;
          let geometryOk = false;
          let predictedCorner = null;  // V25-A: set when a corner was inferred

          if (found.tl && found.tr && found.br && found.bl){
            const candidate = [
              { x: tl.x, y: tl.y },
              { x: tr.x, y: tr.y },
              { x: br.x, y: br.y },
              { x: bl.x, y: bl.y }
            ];
            if (validateGeometry(candidate)){
              corners = candidate;
              geometryOk = true;
            }
          }

          // V25-A: score-weighted parallelogram fallback \u2014 if three
          // corners score \u2265STRONG predict the weak corner by
          // diagonals-bisect identity (TL = BL+TR-BR, etc).
          if (!corners){
            const STRONG = 0.40;
            const strong = {
              tl: scores.tl >= STRONG, tr: scores.tr >= STRONG,
              br: scores.br >= STRONG, bl: scores.bl >= STRONG
            };
            const strongCount = (strong.tl?1:0) + (strong.tr?1:0) + (strong.br?1:0) + (strong.bl?1:0);
            if (strongCount === 3){
              const p = { tl: tl, tr: tr, br: br, bl: bl };
              let weakKey = null;
              if (!strong.tl) weakKey = 'tl';
              else if (!strong.tr) weakKey = 'tr';
              else if (!strong.br) weakKey = 'br';
              else weakKey = 'bl';
              let predicted = null;
              if (weakKey === 'tl')      predicted = { x: p.bl.x + p.tr.x - p.br.x, y: p.bl.y + p.tr.y - p.br.y };
              else if (weakKey === 'tr') predicted = { x: p.tl.x + p.br.x - p.bl.x, y: p.tl.y + p.br.y - p.bl.y };
              else if (weakKey === 'br') predicted = { x: p.tr.x + p.bl.x - p.tl.x, y: p.tr.y + p.bl.y - p.tl.y };
              else if (weakKey === 'bl') predicted = { x: p.tl.x + p.br.x - p.tr.x, y: p.tl.y + p.br.y - p.tr.y };

              if (predicted
                  && predicted.x > -width * 0.2 && predicted.x < width * 1.2
                  && predicted.y > -height * 0.2 && predicted.y < height * 1.2){
                const candidate = [
                  weakKey === 'tl' ? predicted : { x: tl.x, y: tl.y },
                  weakKey === 'tr' ? predicted : { x: tr.x, y: tr.y },
                  weakKey === 'br' ? predicted : { x: br.x, y: br.y },
                  weakKey === 'bl' ? predicted : { x: bl.x, y: bl.y }
                ];
                if (validateGeometry(candidate)){
                  corners = candidate;
                  geometryOk = true;
                  predictedCorner = weakKey;
                  // Mark predicted corner as found so the UI shows it
                  // as accepted; raw score stays low so the badge
                  // still reads amber / weak-ish.
                  found[weakKey] = true;
                }
              }
            }
          }

          return {
            corners: corners,
            scores: scores,
            found: found,
            geometryOk: geometryOk,
            predictedCorner: predictedCorner
          };
        }

        /* V23 bullet-hole detection: blur -> Otsu+offset threshold -> CC labelling -> ellipse fit. */
        function detectDarkBlobs(canvas, options = {}){
          const ctx = canvas.getContext('2d', { willReadFrequently: true });
          const {width, height} = canvas;
          const img = ctx.getImageData(0, 0, width, height);
          const gray = toGrayscale(img);
          const smoothed = gaussianBlur3x3(gray, width, height);
          const ii = buildIntegralImage(smoothed, width, height);

          const threshold          = options.threshold          ?? 92;
          const minArea            = options.minArea            ?? 28;
          const maxArea            = options.maxArea            ?? 1400;
          const minCircularity     = options.minCircularity     ?? 0.22;
          const minSolidity        = options.minSolidity        ?? 0.55;
          const minThickness       = options.minThickness       ?? 3;
          const maxAspect          = options.maxAspect          ?? 2.4;
          const excludeMargin      = options.excludeMargin      ?? 40;
          const markerExclusionPx  = options.markerExclusionPx  ?? 0;
          const mergeDistance      = options.mergeDistance      ?? 0;
          const adaptiveOffset     = options.adaptiveOffset     ?? 18;
          const returnMask         = !!options.returnMask;

          // Adaptive half-window ≈ 3.3% of the shorter dimension; big enough
          // to average out paper grain but small enough to track genuine
          // lighting gradients across the target.
          const adaptiveHalf = Math.max(12, Math.round(Math.min(width, height) / 30));
          // Cap above which adaptive thresholding won't trigger -- prevents
          // mid-gray smudges on bright paper from lighting up.
          const adaptiveCap = Math.min(190, threshold + 55);

          // Binary mask build: global OR adaptive.
          const mask = new Uint8Array(width * height);
          for (let y = 0; y < height; y++){
            const rowBase = y * width;
            for (let x = 0; x < width; x++){
              const g = smoothed[rowBase + x];
              if (g < threshold){
                mask[rowBase + x] = 1;
              } else if (g < adaptiveCap){
                const localMean = integralRectMean(ii,
                  x - adaptiveHalf, y - adaptiveHalf,
                  x + adaptiveHalf, y + adaptiveHalf);
                if (g < localMean - adaptiveOffset) mask[rowBase + x] = 1;
              }
            }
          }

          // Corner exclusion: zero the four square regions where the
          // reference markers sit on the rectified canvas.
          if (markerExclusionPx > 0){
            const m = Math.min(markerExclusionPx, Math.floor(Math.min(width, height) / 2));
            for (let y = 0; y < m; y++){
              const row = y * width;
              for (let x = 0; x < m; x++) mask[row + x] = 0;
              for (let x = width - m; x < width; x++) mask[row + x] = 0;
            }
            for (let y = height - m; y < height; y++){
              const row = y * width;
              for (let x = 0; x < m; x++) mask[row + x] = 0;
              for (let x = width - m; x < width; x++) mask[row + x] = 0;
            }
          }

          // 8-connected component labelling with 4-connected perimeter counting.
          // V24: accumulate second moments (sumXX / sumYY / sumXY) so that
          // after optional merging we can compute a proper ellipse fit.
          const visited = new Uint8Array(width * height);
          const dirs = [1, -1, width, -width, width + 1, width - 1, -width + 1, -width - 1];
          const rawBlobs = [];

          for (let y = excludeMargin; y < height - excludeMargin; y++){
            for (let x = excludeMargin; x < width - excludeMargin; x++){
              const start = y * width + x;
              if (!mask[start] || visited[start]) continue;
              const q = [start];
              visited[start] = 1;
              let area = 0, sumX = 0, sumY = 0, sumXX = 0, sumYY = 0, sumXY = 0;
              let perimeter = 0;
              let minX = x, minY = y, maxX = x, maxY = y;

              while (q.length){
                const p = q.pop();
                const px = p % width;
                const py = (p - px) / width;
                area++;
                sumX += px;
                sumY += py;
                sumXX += px * px;
                sumYY += py * py;
                sumXY += px * py;
                if (px < minX) minX = px;
                if (px > maxX) maxX = px;
                if (py < minY) minY = py;
                if (py > maxY) maxY = py;

                // 4-neighbour perimeter.
                const n1 = p + 1, n2 = p - 1, n3 = p + width, n4 = p - width;
                if (px + 1 >= width || !mask[n1]) perimeter++;
                if (px - 1 < 0      || !mask[n2]) perimeter++;
                if (py + 1 >= height|| !mask[n3]) perimeter++;
                if (py - 1 < 0      || !mask[n4]) perimeter++;

                // 8-neighbour expansion.
                for (let k = 0; k < 8; k++){
                  const n = p + dirs[k];
                  if (n < 0 || n >= width * height) continue;
                  const nx = n % width;
                  const ny = (n - nx) / width;
                  if (nx < 0 || nx >= width || ny < 0 || ny >= height) continue;
                  if (mask[n] && !visited[n]){ visited[n] = 1; q.push(n); }
                }
              }

              if (area < minArea || area > maxArea) continue;
              const bboxW = maxX - minX + 1;
              const bboxH = maxY - minY + 1;
              if (Math.min(bboxW, bboxH) < minThickness) continue;
              const aspect = bboxW > bboxH ? bboxW / bboxH : bboxH / bboxW;
              if (aspect > maxAspect) continue;
              const circularity = (4 * Math.PI * area) / Math.max(perimeter * perimeter, 1);
              if (circularity < minCircularity) continue;
              const solidity = area / Math.max(bboxW * bboxH, 1);
              if (solidity < minSolidity) continue;

              rawBlobs.push({
                sumX: sumX, sumY: sumY,
                sumXX: sumXX, sumYY: sumYY, sumXY: sumXY,
                area: area,
                minX: minX, maxX: maxX,
                minY: minY, maxY: maxY,
                // V29: keep per-blob shape metrics for top-N quality scoring.
                circularity: circularity,
                solidity: solidity
              });
            }
          }

          // Compute final ellipse params for a single (possibly-merged) blob
          // from its raw moment sums.
          function finaliseBlob(b){
            const mx = b.sumX / b.area;
            const my = b.sumY / b.area;
            const Cxx = b.sumXX / b.area - mx * mx;
            const Cyy = b.sumYY / b.area - my * my;
            const Cxy = b.sumXY / b.area - mx * my;
            const trace = Cxx + Cyy;
            const det = Cxx * Cyy - Cxy * Cxy;
            const discr = Math.max(0, (trace * trace) * 0.25 - det);
            const sqrtD = Math.sqrt(discr);
            const lambda1 = Math.max(0, trace * 0.5 + sqrtD);
            const lambda2 = Math.max(0, trace * 0.5 - sqrtD);
            // For a uniformly-filled ellipse, Var(axis) = (semi-axis)^2 / 4,
            // so semi-axis = 2 * sqrt(lambda). Diameter = 4 * sqrt(lambda).
            const majorDiam = 4 * Math.sqrt(lambda1);
            const minorDiam = 4 * Math.sqrt(lambda2);
            const theta = 0.5 * Math.atan2(2 * Cxy, Cxx - Cyy);
            // V29: shape-quality score combining circularity and solidity.
            // Both are 0\u20131 metrics where higher = more like a clean
            // round bullet hole. Multiplied so a fragment that fails on
            // either dimension scores low. circularity & solidity may be
            // missing on merged-cluster blobs (we recompute them below).
            const circ = (typeof b.circularity === 'number') ? b.circularity : 0;
            const sol  = (typeof b.solidity === 'number')    ? b.solidity    : 0;
            const quality = Math.max(0, Math.min(1, circ * sol));
            return {
              x: mx,
              y: my,
              bboxW: b.maxX - b.minX + 1,
              bboxH: b.maxY - b.minY + 1,
              area: b.area,
              majorDiam: majorDiam,
              minorDiam: minorDiam,
              theta: theta,
              quality: quality
            };
          }

          let finalBlobs;
          if (rawBlobs.length < 2 || mergeDistance <= 0){
            finalBlobs = rawBlobs.map(finaliseBlob);
          } else {
            // Merge blobs whose centres fall within mergeDistance. Fragmented
            // bullet holes (torn paper with an island of remaining fibre)
            // would otherwise be reported as 2-3 overlapping shots. Moments
            // are summed across the cluster so the merged ellipse reflects
            // the union of pixels, not any single fragment.
            const merged = [];
            const used = new Array(rawBlobs.length).fill(false);
            const mergeSq = mergeDistance * mergeDistance;

            // Pre-compute centres for distance comparisons.
            const cx = rawBlobs.map((b) => b.sumX / b.area);
            const cy = rawBlobs.map((b) => b.sumY / b.area);

            for (let i = 0; i < rawBlobs.length; i++){
              if (used[i]) continue;
              const clusterIdx = [i];
              used[i] = true;
              let changed = true;
              while (changed){
                changed = false;
                for (let j = 0; j < rawBlobs.length; j++){
                  if (used[j]) continue;
                  for (let c = 0; c < clusterIdx.length; c++){
                    const ci = clusterIdx[c];
                    const ddx = cx[ci] - cx[j];
                    const ddy = cy[ci] - cy[j];
                    if ((ddx * ddx + ddy * ddy) < mergeSq){
                      clusterIdx.push(j);
                      used[j] = true;
                      changed = true;
                      break;
                    }
                  }
                }
              }
              // Combine moment sums across the cluster.
              let sX = 0, sY = 0, sXX = 0, sYY = 0, sXY = 0, a = 0;
              let miX = Infinity, maX = -Infinity, miY = Infinity, maY = -Infinity;
              // V29: weight per-blob shape metrics by area so the merged
              // cluster's quality reflects what the dominant fragment
              // looked like.
              let circWeighted = 0, solWeighted = 0, weightTotal = 0;
              for (let c = 0; c < clusterIdx.length; c++){
                const b = rawBlobs[clusterIdx[c]];
                sX += b.sumX; sY += b.sumY;
                sXX += b.sumXX; sYY += b.sumYY; sXY += b.sumXY;
                a += b.area;
                circWeighted += (b.circularity || 0) * b.area;
                solWeighted  += (b.solidity   || 0) * b.area;
                weightTotal  += b.area;
                if (b.minX < miX) miX = b.minX;
                if (b.maxX > maX) maX = b.maxX;
                if (b.minY < miY) miY = b.minY;
                if (b.maxY > maY) maY = b.maxY;
              }
              merged.push(finaliseBlob({
                sumX: sX, sumY: sY, sumXX: sXX, sumYY: sYY, sumXY: sXY,
                area: a,
                minX: miX, maxX: maX, minY: miY, maxY: maY,
                circularity: weightTotal > 0 ? (circWeighted / weightTotal) : 0,
                solidity:    weightTotal > 0 ? (solWeighted  / weightTotal) : 0
              }));
            }
            finalBlobs = merged;
          }

          return {
            blobs: finalBlobs,
            mask: returnMask ? mask : null
          };
        }

        function drawSourcePreview(foundCorners = null){
          const source = els.sourceCanvas, preview = els.previewCanvas;
          if (!source.width) return;
          preview.width = source.width; preview.height = source.height;
          const ctx = preview.getContext('2d');
          ctx.clearRect(0,0,preview.width,preview.height);
          ctx.drawImage(source,0,0);

          // V37 (e): scale dot dimensions by canvas size so they
          // remain visible on high-res phone photos shown at ~350px
          // CSS width.
          const maxDim = Math.max(source.width, source.height);
          const dotR = Math.max(12, Math.round(maxDim / 60));
          const ringW = Math.max(3, Math.round(maxDim / 240));
          const labelFontPx = Math.max(14, Math.round(maxDim / 50));
          const labelOffset = Math.max(10, Math.round(maxDim / 100));
          const labelBoxW = Math.max(26, Math.round(maxDim / 30));
          const labelBoxH = Math.max(16, Math.round(maxDim / 50));

          const pts = foundCorners || state.corners;
          if (pts && pts.length === 4){
            ctx.strokeStyle = '#d97927';
            ctx.lineWidth = ringW;
            ctx.beginPath();
            ctx.moveTo(pts[0].x, pts[0].y);
            for (let i=1; i<4; i++) ctx.lineTo(pts[i].x, pts[i].y);
            ctx.closePath(); ctx.stroke();

            // V39 (b): coloured corner markers re-introduced (one
            // colour per corner so TL/TR/BR/BL are individually
            // identifiable) but kept as solid filled discs with a
            // thin dark ring \u2014 no white halo this time.
            const markerColors = ['#1f6feb','#2e7d32','#c62828','#d97927'];
            const SOLID_DOT_RING = '#1a1410';
            pts.forEach((p,i) => {
              ctx.fillStyle = markerColors[i] || '#d97927';
              ctx.beginPath(); ctx.arc(p.x,p.y,dotR,0,Math.PI*2); ctx.fill();
              ctx.strokeStyle = SOLID_DOT_RING;
              ctx.lineWidth = Math.max(2, Math.round(ringW * 0.6));
              ctx.beginPath(); ctx.arc(p.x,p.y,dotR,0,Math.PI*2); ctx.stroke();
              ctx.fillStyle = '#fff';
              ctx.font = 'bold ' + labelFontPx + 'px sans-serif';
              ctx.textAlign = 'center';
              ctx.textBaseline = 'middle';
              ctx.fillText(String(i+1), p.x, p.y);
              ctx.textAlign = 'start';
              ctx.textBaseline = 'alphabetic';
            });
          }

          // V40 (b): manual-corners pass removed; foundCorners block
          // already paints all four with correct per-corner colour.
        }

        function redrawRectifiedOverlay(nextShots = null){
          const canvas = els.rectifiedCanvas;
          if (!canvas.width) return;
          const ctx = canvas.getContext('2d', { willReadFrequently: true });
          const targetWMm = getTargetWidthMm();
          const targetHMm = getTargetHeightMm();
          const marginMm = getReferenceMarginMm();

          if (state.rectifiedBaseImageData) ctx.putImageData(state.rectifiedBaseImageData, 0, 0);
          else ctx.clearRect(0,0,canvas.width,canvas.height);

          const currentShots = nextShots || state.shots;

          // V24: debug mask overlay -- paints every pixel the detector
          // classified as dark in translucent red. Drawn BEFORE the grid,
          // markers and shots so those remain fully legible on top.
          // putImageData replaces pixels (doesn't alpha-blend), so we route
          // the overlay through an offscreen canvas and drawImage it back,
          // which does honour the alpha channel.

          const markerMarginPx  = (marginMm / targetWMm) * canvas.width;
          const markerMarginPxY = (marginMm / targetHMm) * canvas.height;
          const markerPoints = [
            {x: markerMarginPx, y: markerMarginPxY, color:'rgba(31,111,235,0.92)', label:'TL'},
            {x: canvas.width - markerMarginPx, y: markerMarginPxY, color:'rgba(46,125,50,0.92)', label:'TR'},
            {x: canvas.width - markerMarginPx, y: canvas.height - markerMarginPxY, color:'rgba(198,40,40,0.92)', label:'BR'},
            {x: markerMarginPx, y: canvas.height - markerMarginPxY, color:'rgba(217,121,39,0.96)', label:'BL'}
          ];
          markerPoints.forEach((p) => {
            ctx.strokeStyle = p.color;
            ctx.lineWidth = 2;
            ctx.beginPath();
            ctx.moveTo(p.x - 12, p.y);
            ctx.lineTo(p.x + 12, p.y);
            ctx.moveTo(p.x, p.y - 12);
            ctx.lineTo(p.x, p.y + 12);
            ctx.stroke();
            ctx.fillStyle = '#ffffff';
            ctx.fillRect(p.x + 10, p.y - 18, 28, 16);
            ctx.fillStyle = p.color;
            ctx.font = 'bold 11px sans-serif';
            ctx.fillText(p.label, p.x + 14, p.y - 6);
          });

          if (currentShots.length >= 2){
            const groupCircle = largestSpreadCircle(currentShots);
            if (groupCircle){
              ctx.strokeStyle = state.lockRectified ? 'rgba(217,121,39,0.55)' : 'rgba(217,121,39,0.92)';
              ctx.lineWidth = 3;
              ctx.setLineDash([10,8]);
              ctx.beginPath();
              ctx.arc(groupCircle.x, groupCircle.y, groupCircle.r, 0, Math.PI * 2);
              ctx.stroke();
              ctx.setLineDash([]);

              ctx.fillStyle = state.lockRectified ? 'rgba(217,121,39,0.58)' : 'rgba(217,121,39,0.96)';
              ctx.beginPath();
              ctx.arc(groupCircle.x, groupCircle.y, 4.5, 0, Math.PI * 2);
              ctx.fill();

              ctx.strokeStyle = state.lockRectified ? 'rgba(217,121,39,0.58)' : 'rgba(217,121,39,0.95)';
              ctx.lineWidth = 2;
              ctx.beginPath();
              ctx.moveTo(groupCircle.a.x, groupCircle.a.y);
              ctx.lineTo(groupCircle.b.x, groupCircle.b.y);
              ctx.stroke();
            }
          }

          if (currentShots.length >= 1){
            const c = centroid(currentShots);
            const size = 20;
            ctx.fillStyle = state.lockRectified ? 'rgba(123,44,191,0.55)' : 'rgba(123,44,191,0.96)';
            ctx.beginPath();
            ctx.moveTo(c.x, c.y - size);
            ctx.lineTo(c.x + size * 0.9, c.y + size * 0.7);
            ctx.lineTo(c.x - size * 0.9, c.y + size * 0.7);
            ctx.closePath();
            ctx.fill();
            ctx.strokeStyle = 'rgba(255,255,255,0.96)';
            ctx.lineWidth = 2;
            ctx.stroke();
          }

          currentShots.forEach((s,i) => {
            // V29: round-only shot rendering. Cold-bore shot draws blue;
            // every other shot stays red.
            // V30: all shots draw at the same fixed radius regardless of
            // detected hole size, so the user sees a consistent group
            // visual instead of a spread of variable-sized rings.
            const isColdBore = (state.coldBoreShotIndex === i);
            const colour = isColdBore
              ? (state.lockRectified ? 'rgba(45,127,214,0.55)' : '#2d7fd6')
              : (state.lockRectified ? 'rgba(198,40,40,0.55)' : '#c62828');
            ctx.strokeStyle = colour;
            ctx.lineWidth = 3;

            const radius = 12;
            ctx.beginPath();
            ctx.arc(s.x, s.y, radius, 0, Math.PI * 2);
            ctx.stroke();

            ctx.fillStyle = colour;
            ctx.beginPath(); ctx.arc(s.x,s.y,4,0,Math.PI*2); ctx.fill();
            ctx.fillStyle = state.lockRectified ? 'rgba(24,32,27,0.5)' : '#18201b';
            ctx.font = 'bold 18px sans-serif';
            const labelOffset = radius + 4;
            ctx.fillText(String(i+1), s.x + labelOffset, s.y - 10);

            // V29: cold-bore badge above the shot circle so the user can
            // tell which shot is the cold-bore round at a glance even if
            // the colour-coding fails them on a sun-glared phone screen.
            if (isColdBore){
              const badgeY = s.y - radius - 14;
              const badgeText = 'COLD BORE';
              ctx.font = 'bold 10px sans-serif';
              const tw = ctx.measureText(badgeText).width;
              ctx.fillStyle = state.lockRectified ? 'rgba(45,127,214,0.55)' : '#2d7fd6';
              ctx.fillRect(s.x - (tw / 2) - 6, badgeY - 8, tw + 12, 16);
              ctx.fillStyle = '#ffffff';
              ctx.fillText(badgeText, s.x - (tw / 2), badgeY + 3);
            }
          });
        }

        function updateMetrics(){
          const pixelsPerMm = getPixelsPerMm();

          let groupStr = '-';
          if (state.shots.length < 2){
            els.groupSize.textContent = '-';
          } else {
            let maxPx = 0;
            for (let i=0; i<state.shots.length; i++){
              for (let j=i+1; j<state.shots.length; j++){
                maxPx = Math.max(maxPx, distance(state.shots[i], state.shots[j]));
              }
            }
            const extremeMmCenter = maxPx / pixelsPerMm;
            groupStr = formatLength(extremeMmCenter);
            els.groupSize.textContent = groupStr;
          }

          let poiXStr = '-';
          let poiYStr = '-';
          if (state.shots.length >= 1 && els.rectifiedCanvas.width && els.rectifiedCanvas.height){
            const center = centroid(state.shots);
            const aimX = els.rectifiedCanvas.width / 2;
            const aimY = els.rectifiedCanvas.height / 2;
            const dxMm = (center.x - aimX) / pixelsPerMm;
            const dyMm = (center.y - aimY) / pixelsPerMm;
            state.poiOffsetMm = { x: dxMm, y: dyMm };
            poiXStr = formatPoiOffset(dxMm, 'x');
            poiYStr = formatPoiOffset(dyMm, 'y');
            els.poiX.textContent = poiXStr;
            els.poiY.textContent = poiYStr;
          } else {
            state.poiOffsetMm = { x: 0, y: 0 };
            els.poiX.textContent = '-';
            els.poiY.textContent = '-';
          }

          // V28: expected-shots mismatch + mini-bar sync.
          syncExpectedShotsUI();
          syncMiniMetricsValues(groupStr, poiXStr, poiYStr);
          // V31: paint Cold Bore POI X/Y metrics. Shows "--" when no
          // cold-bore shot is tagged. The same "RIGHT/LEFT/HIGH/LOW"
          // formatting as the average POI metrics is used so the user
          // reads them consistently.
          syncColdBoreMetrics(pixelsPerMm);

          queueBrowserAutoSave();
        }

        function syncColdBoreMetrics(pixelsPerMm){
          if (!els.coldBorePoiX || !els.coldBorePoiY) return;
          const idx = state.coldBoreShotIndex;
          const canvas = els.rectifiedCanvas;
          const hasCanvas = canvas && canvas.width && canvas.height;
          if (idx == null || !state.shots[idx] || !hasCanvas || !pixelsPerMm){
            els.coldBorePoiX.textContent = '\u2014';
            els.coldBorePoiY.textContent = '\u2014';
            if (els.coldBoreXMetric) els.coldBoreXMetric.classList.remove('is-active');
            if (els.coldBoreYMetric) els.coldBoreYMetric.classList.remove('is-active');
            // V36: clear cached cold-bore offsets so the Terra-Dial
            // transfer handler can tell when there's no valid value.
            state.coldBorePoiOffsetMm = null;
            return;
          }
          const aimX = canvas.width / 2;
          const aimY = canvas.height / 2;
          const s = state.shots[idx];
          const dx = (s.x - aimX) / pixelsPerMm;
          const dy = (s.y - aimY) / pixelsPerMm;
          els.coldBorePoiX.textContent = formatPoiOffset(dx, 'x');
          els.coldBorePoiY.textContent = formatPoiOffset(dy, 'y');
          if (els.coldBoreXMetric) els.coldBoreXMetric.classList.add('is-active');
          if (els.coldBoreYMetric) els.coldBoreYMetric.classList.add('is-active');
          // V36: cache for Terra-Dial transfer.
          state.coldBorePoiOffsetMm = { x: dx, y: dy };
        }

        // V28: paint the Shots metric to reflect state.expectedShots.
        // V54: shotsCount value renders as "5 of 8" when expected is set
        // so the comparison is obvious at a glance, "5" alone otherwise.
        function syncExpectedShotsUI(){
          if (!els.shotsMetric) return;
          const actual = state.shots.length;
          const expected = state.expectedShots;

          // Default to neutral (no mismatch / match / over classes).
          els.shotsMetric.classList.remove('is-mismatch', 'is-match', 'is-over');

          // No expectation set -> just the count.
          if (expected == null || !isFinite(expected) || expected <= 0){
            els.shotsCount.textContent = String(actual);
            state.lastMismatchState = null;
            return;
          }

          els.shotsCount.textContent = `${actual} of ${expected}`;
          const isMismatch = actual !== expected;
          const isOver = actual > expected;
          // V33: red when over count, amber when under count, green at parity.
          els.shotsMetric.classList.toggle('is-over', isOver);
          els.shotsMetric.classList.toggle('is-mismatch', isMismatch && !isOver);
          els.shotsMetric.classList.toggle('is-match', !isMismatch && actual > 0);

          // Haptic success pulse on transition into match (only once per
          // rising edge, so adding then re-editing doesn't buzz repeatedly).
          if (!isMismatch && state.lastMismatchState === true && actual > 0){
            haptic('match');
          }
          state.lastMismatchState = isMismatch;
        }

        // V28: propagate the latest metric strings into the sticky mini bar.
        // Compact POI format uses arrows and tabular-numerics to stay
        // readable inside ~80 px per column on narrow phones.
        function syncMiniMetricsValues(groupStr, poiXStr, poiYStr){
          if (!els.miniMetrics) return;
          const actual = state.shots.length;
          const expected = state.expectedShots;
          const showExpected = expected != null && expected > 0;

          if (els.miniShots){
            els.miniShots.textContent = showExpected
              ? `${actual}/${expected}`
              : String(actual);
          }
          if (els.miniGroup){
            els.miniGroup.textContent = (groupStr && groupStr !== '-') ? groupStr : '—';
          }
          // V66: arrow form parses any unit (mm or in); echoes same unit back
          const mini = (str) => {
            if (!str || str === '-') return '—';
            const m = str.match(/^(\d+(?:\.\d+)?)\s*(mm|in)\s+(RIGHT|LEFT|HIGH|LOW)$/);
            if (!m) return str;
            const n = m[1], unit = m[2], dir = m[3];
            const arrow = dir === 'RIGHT' ? '→' : dir === 'LEFT' ? '←' : dir === 'LOW' ? '↓' : '↑';
            return `${arrow} ${n}${unit}`;
          };
          if (els.miniPoiX) els.miniPoiX.textContent = mini(poiXStr);
          if (els.miniPoiY) els.miniPoiY.textContent = mini(poiYStr);

          // Flag the mini Shots cell amber on mismatch.
          const miniShotsCell = els.miniShots && els.miniShots.parentElement;
          if (miniShotsCell){
            const isMismatch = showExpected && actual !== expected;
            const isOver = showExpected && actual > expected;
            miniShotsCell.classList.toggle('is-over', isOver);
            miniShotsCell.classList.toggle('is-mismatch', isMismatch && !isOver);
          }
        }

        // V28: sticky mini-metrics show/hide on scroll. Only binds on
        // narrow viewports (the CSS hides the bar on desktop regardless,
        // but skipping the listener saves a cycle). Uses the main
        // metrics block's bottom edge as the reveal trigger.
        function updateMiniMetricsVisibility(){
          if (!els.miniMetrics) return;
          const mainMetrics = root.querySelector('.terra-metrics');
          if (!mainMetrics){
            els.miniMetrics.classList.remove('is-visible');
            state.miniMetricsVisible = false;
            return;
          }
          // Only meaningful on mobile/tablet widths.
          if (window.innerWidth > 980){
            if (state.miniMetricsVisible){
              els.miniMetrics.classList.remove('is-visible');
              state.miniMetricsVisible = false;
            }
            return;
          }
          // Dock under the store header (Dawn keeps it sticky and shrinks
          // it on scroll), so the bar never covers the site menu.
          const header = document.querySelector('.section-header');
          const top = header ? Math.max(0, Math.round(header.getBoundingClientRect().bottom)) : 0;
          if (top !== state.miniMetricsTop){
            els.miniMetrics.style.setProperty('--terra-mini-top', top + 'px');
            state.miniMetricsTop = top;
          }
          const r = mainMetrics.getBoundingClientRect();
          // Reveal bar when main metrics have scrolled out the top
          // and the rectified target / shot-actions area is still
          // above the fold (i.e. user is still interacting with shots).
          const shouldShow = r.bottom < 0 || r.top > window.innerHeight;
          if (shouldShow !== state.miniMetricsVisible){
            els.miniMetrics.classList.toggle('is-visible', shouldShow);
            state.miniMetricsVisible = shouldShow;
          }
        }

        // V28: light haptic feedback helper. No-op when the browser
        // doesn't support the Vibration API (iOS Safari), and respects
        // prefers-reduced-motion for users who find vibration distracting.
        function haptic(kind){
          try {
            if (typeof navigator === 'undefined' || typeof navigator.vibrate !== 'function') return;
            if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
            if (kind === 'place')      navigator.vibrate(25);
            else if (kind === 'delete') navigator.vibrate([15, 50, 15]);
            else if (kind === 'match')  navigator.vibrate([20, 60, 20, 60, 20]);
          } catch(_){}
        }

        function resetWorkingState(){
          state.manualCorners = [];
          state.placingManualMarkers = false;
          state.corners = null;
          state.shots = [];
          state.rectifiedBaseImageData = null;
          state.poiOffsetMm = { x: 0, y: 0 };
          state.baseCorners = null;
          // V24: clear Otsu cache, debug mask, and corner-score state so the
          // UI doesn't carry stale confidence/threshold data into the new
          // image. The readouts will repopulate on the first detection pass.
          state.otsuThreshold = null;
          state.cornerScores = { tl: 0, tr: 0, br: 0, bl: 0 };
          state.cornerFound = { tl: false, tr: false, br: false, bl: false };
          state.cornerFromFallback = false;
          state.predictedCorner = null;
          // V27: new image = reset the "user has manually toggled" flag
          // so auto-collapse logic runs fresh for the new detection.
          state.fineTuneUserOverride = false;
          // V29: new image = reset workflow stage so cards re-progress
          // through the staged reveal as the user moves through them.
          state.sourceLocked = false;
          state.shotsDetected = false;
          state.coldBoreShotIndex = null;
          // V26: visibly clear the rectified canvas so the previous
          // photo's detection doesn't flicker behind the incoming one.
          // Dimensions are reset to 0x0 -- the next rectification pass
          // will size them to match the new preset / image.
          if (els.rectifiedCanvas && els.rectifiedCanvas.width){
            const rctx = els.rectifiedCanvas.getContext('2d', { willReadFrequently: true });
            rctx.clearRect(0, 0, els.rectifiedCanvas.width, els.rectifiedCanvas.height);
            els.rectifiedCanvas.width = 0;
            els.rectifiedCanvas.height = 0;
          }
          // V26: also clear the source preview so the old photo doesn't
          // persist while the new one is being decoded. The full preview
          // repaint happens in loadImageFromFile -> drawSourcePreview.
          if (els.previewCanvas && els.previewCanvas.width){
            const pctx = els.previewCanvas.getContext('2d');
            pctx.clearRect(0, 0, els.previewCanvas.width, els.previewCanvas.height);
          }
          resetFineTuneOffsets();
          syncManualMarkerUI();
          syncCornerInputs();
          resetRectifiedViewport();
          updateThresholdReadout();
          updateCornerConfidenceBadges({ reset: true });
          updateMetrics();
          syncColdBoreUI();
          syncWorkflowVisibility();
          syncLockPill();
        }


        function renderFromCornersOnly(foundCorners){
          const source = els.sourceCanvas;
          if (!source.width || !foundCorners || foundCorners.length !== 4) {
            setRerunButtonState('idle');
            return false;
          }

          state.corners = foundCorners.map((p) => ({ x: p.x, y: p.y }));
          state.manualCorners = foundCorners.map((p) => ({ x: p.x, y: p.y }));
          drawSourcePreview(foundCorners);

          const rectified = drawRectifiedImage(source, foundCorners);
          if (!rectified){
            setStatus('Target rectification failed.');
            setRerunButtonState('idle');
            return false;
          }

          els.rectifiedCanvas.width = rectified.width;
          els.rectifiedCanvas.height = rectified.height;
          const outCtx = els.rectifiedCanvas.getContext('2d', { willReadFrequently: true });
          outCtx.drawImage(rectified, 0, 0);
          state.rectifiedBaseImageData = outCtx.getImageData(0, 0, els.rectifiedCanvas.width, els.rectifiedCanvas.height);
          // V24: any rectification change invalidates the cached Otsu
          // threshold and any previously-captured debug mask.
          state.otsuThreshold = null;
          updateThresholdReadout();
          // V30: paint grid + corner crosshair markers (and any existing
          // shots) on top of the freshly rectified image so the user
          // never sees a "naked" rectified canvas after fine-tuning.
          redrawRectifiedOverlay();
          applyRectifiedViewport();
          return true;
        }

        // V24/V25-C: cached Otsu over rectified pixels excluding the
        // four corner marker regions (pure-black markers would skew low).
        function ensureOtsuThreshold(){
          if (state.otsuThreshold != null) return state.otsuThreshold;
          const canvas = els.rectifiedCanvas;
          if (!canvas.width || !canvas.height) return null;
          const ctx = canvas.getContext('2d', { willReadFrequently: true });
          const img = ctx.getImageData(0, 0, canvas.width, canvas.height);
          const gray = toGrayscale(img);

          // Corner exclusion: marker footprint + 3 mm buffer.
          const pxPerMm = getPixelsPerMm();
          const m = Math.min(
            Math.round(pxPerMm * (MARKER_SIZE_MM + 3)),
            Math.floor(Math.min(canvas.width, canvas.height) / 2)
          );
          if (m > 0){
            const roi = new Uint8ClampedArray(gray.length - (4 * m * m));
            let w = 0;
            for (let y = 0; y < canvas.height; y++){
              const inVertBand = y < m || y >= canvas.height - m;
              const rowBase = y * canvas.width;
              for (let x = 0; x < canvas.width; x++){
                const inCorner = inVertBand && (x < m || x >= canvas.width - m);
                if (inCorner) continue;
                roi[w++] = gray[rowBase + x];
              }
            }
            // Use only the filled portion of the buffer.
            state.otsuThreshold = computeOtsuThreshold(roi.subarray(0, w));
          } else {
            state.otsuThreshold = computeOtsuThreshold(gray);
          }
          return state.otsuThreshold;
        }

        // V24: refresh the threshold readout ( Auto · Offset · Effective ).
        function updateThresholdReadout(){
          if (!els.thresholdAuto || !els.thresholdValue || !els.thresholdEffective) return;
          const auto = state.otsuThreshold;
          const offset = Number(els.threshold.value || 0);
          els.thresholdAuto.textContent = auto == null ? '—' : String(auto);
          els.thresholdValue.textContent = (offset > 0 ? '+' : '') + String(offset);
          els.thresholdEffective.textContent = auto == null ? '—' : String(Math.max(5, Math.min(230, auto + offset)));
        }

        // V24: paint each corner card's confidence badge from state.cornerScores.
        // Strength tiers are tuned against the V23 acceptance threshold of 0.30
        // so "is-ok" roughly corresponds to "passed but not dominant".
        // V25-A: a corner that was inferred by parallelogram completion
        // gets labelled "inferred" with the amber is-ok colour.
        function updateCornerConfidenceBadges(opts){
          const options = opts || {};
          const corners = ['tl','tr','br','bl'];
          for (let i = 0; i < 4; i++){
            const key = corners[i];
            const el = els.cornerConf && els.cornerConf[key];
            if (!el) continue;
            el.classList.remove('is-strong','is-ok','is-weak','is-fallback','is-inferred');
            if (options.reset){
              el.textContent = '—';
              continue;
            }
            if (state.cornerFromFallback){
              el.textContent = 'fallback';
              el.classList.add('is-fallback');
              continue;
            }
            if (state.predictedCorner === key){
              el.textContent = 'inferred';
              el.classList.add('is-ok', 'is-inferred');
              continue;
            }
            const raw = state.cornerScores[key] || 0;
            // Map raw 0.30 -> 60%, 0.60 -> 100% (typical strong), clip 0-100%.
            const pct = Math.max(0, Math.min(100, Math.round(raw * 130)));
            el.textContent = pct + '%';
            if (!state.cornerFound[key]){
              el.classList.add('is-weak');
            } else if (raw > 0.55){
              el.classList.add('is-strong');
            } else {
              el.classList.add('is-ok');
            }
          }
        }

        function rerunShotDetection(statusPrefix){
          if (!els.rectifiedCanvas.width || !state.rectifiedBaseImageData) {
            setRerunButtonState('idle');
            return;
          }

          if (state.rectifiedBaseImageData) {
            els.rectifiedCanvas.getContext('2d', { willReadFrequently: true }).putImageData(state.rectifiedBaseImageData, 0, 0);
          }

          setStatus(`${statusPrefix || 'Rectified target ready.'} Detecting bullet holes…`);
          const pxPerMm = getPixelsPerMm();

          // V24: Otsu-driven threshold. Slider is a ±offset around auto.
          ensureOtsuThreshold();
          const auto = state.otsuThreshold;
          const offset = Number(els.threshold.value || 0);
          const effectiveThreshold = (auto == null ? 92 : auto) + offset;

          const detection = detectDarkBlobs(els.rectifiedCanvas, {
            threshold: Math.max(5, Math.min(230, effectiveThreshold)),
            minArea: 28,
            maxArea: 1400,
            minCircularity: 0.2,
            minSolidity: 0.5,
            // 2 mm safety border around all edges; per-corner marker exclusion
            // below will also cover the marker footprints so this stays small.
            excludeMargin: Math.max(6, Math.round(pxPerMm * 2)),
            // Exclude a square the size of the reference markers in each
            // corner plus a 3 mm buffer. Rectified corners always hold
            // the Terra-Impact markers, not shots.
            markerExclusionPx: Math.round(pxPerMm * (MARKER_SIZE_MM + 3)),
            // Merge fragments of the same hole within 3.5 mm of each other.
            mergeDistance: Math.max(6, Math.round(pxPerMm * 3.5)),
          });

          const rawShots = detection.blobs;
          // Safety net: reject anything bigger than the markers even after
          // marker exclusion (covers sensor glare, dark shadows, etc.).
          const maxMarkerPx = pxPerMm * MARKER_SIZE_MM * 1.35;
          let filtered = rawShots.filter((s) => Math.min(s.bboxW, s.bboxH) < maxMarkerPx);

          // V29: when the user has set Expected shots, sort by quality
          // (combined circularity \xD7 solidity) and keep the top N. This
          // discards weaker candidates so spurious specks don't pollute
          // the group when the round count is known. When Expected is
          // unset, all detections are kept exactly as before.
          let trimmedNote = '';
          if (state.expectedShots != null && state.expectedShots > 0
              && filtered.length > state.expectedShots){
            const sorted = filtered.slice().sort((a, b) => (b.quality || 0) - (a.quality || 0));
            const dropped = filtered.length - state.expectedShots;
            filtered = sorted.slice(0, state.expectedShots);
            trimmedNote = ` (kept top ${state.expectedShots} by quality, dropped ${dropped})`;
          }
          state.shots = filtered;
          state.shotsDetected = true;
          // V34: ensure the first detected shot is auto-tagged as cold
          // bore, and clamp the existing tag if it now points past the
          // (potentially smaller) array.
          ensureColdBoreDefault();

          updateThresholdReadout();
          redrawRectifiedOverlay(filtered);
          updateMetrics();
          syncWorkflowVisibility();
          setStatus(filtered.length
            ? `Detected ${filtered.length} shot${filtered.length === 1 ? '' : 's'}${trimmedNote} \xB7 auto threshold ${auto == null ? '\u2014' : auto}${offset !== 0 ? (offset > 0 ? ' +' : ' ') + offset : ''}.`
            : 'No bullet holes detected automatically. Adjust the offset slider, use Add shot to place manually, or switch to Delete shot to remove mistakes.');
          setRerunButtonState('complete');
        }

        // V59: distance auto-fill via QR code on the printed Terra-
        // Target paper. Accepts bare number, "100m", or URL with
        // ?distance=N. Browsers without BarcodeDetector silently
        // no-op so manual entry is the fallback path.
        function parseDistanceFromQr(raw){
          if (!raw) return null;
          const text = String(raw).trim();
          const urlMatch = text.match(/[?&](?:distance|distance_m)=([0-9]+(?:\.[0-9]+)?)/i);
          if (urlMatch){
            const n = Number(urlMatch[1]);
            if (isFinite(n) && n > 0) return n;
          }
          const bareMatch = text.match(/^([0-9]+(?:\.[0-9]+)?)\s*(?:m|metres?|meters?)?$/i);
          if (bareMatch){
            const n = Number(bareMatch[1]);
            if (isFinite(n) && n > 0 && n < 5000) return n;
          }
          return null;
        }

        function applyAutoDistance(distanceM, sourceLabel){
          if (!els.distanceM || !isFinite(distanceM) || distanceM <= 0) return;
          /* V65: distanceM is metres; status reflects displayed units. */
          setDistanceFromMetres(distanceM);
          els.distanceM.classList.add('is-auto-filled');
          els.distanceM.classList.remove('is-required-empty');
          els.distanceM.dispatchEvent(new Event('input', { bubbles: true }));
          const unitWord = state.unitSystem === 'imperial' ? 'yd' : 'm';
          setStatus(`Distance set to ${els.distanceM.value} ${unitWord} from ${sourceLabel || 'QR code'}.`);
        }

        /* V67 (2026-09-16): the photo QR path used to read ONLY a distance, and only
           from ?distance= - so the 100m MOA sheets' QR (go.terra-target.com.au/t?m=TT11&d=100)
           set NOTHING from a photo, and a TT1-5 print set the distance but left the
           markers on whatever preset was active (a plausible, silently wrong scale).
           Mirrors the app engine (V1.5.1123): whole payload, preset applied first (a
           preset change resets the status line, so the distance message must win). */
        function parseTargetQrPayload(raw){
          if (!raw) return null;
          const text = String(raw).trim();
          const out = {};
          const qi = text.indexOf('?');
          if (qi !== -1){
            try {
              const params = new URLSearchParams(text.slice(qi + 1));
              const d = params.get('distance') || params.get('distance_m') || params.get('d');
              if (d){
                const dm = parseDistanceParam(d);
                if (isFinite(dm) && dm > 0) out.distanceM = dm;
              }
              const pv = (params.get('m') || params.get('preset') || '').trim();
              if (pv){
                const upper = pv.toUpperCase();
                const key = PRESET_LABEL_TO_KEY[upper] || (PRESETS[pv] ? pv : null);
                if (key && PRESETS[key]) out.presetKey = key;
              }
              if (params.get('s')) out.label = params.get('s');
              if (params.get('r')) out.rifle = params.get('r');
              if (params.get('c')) out.calibre = params.get('c');
            } catch(_){}
          }
          if (out.distanceM == null){
            const legacy = parseDistanceFromQr(text);
            if (legacy) out.distanceM = legacy;
          }
          return (out.distanceM != null || out.presetKey) ? out : null;
        }

        function applyQrPayload(payload, sourceLabel){
          if (!payload) return;
          state.lastQrPayload = payload;
          if (payload.presetKey) applyPresetChange(payload.presetKey);
          if (payload.distanceM){
            applyAutoDistance(payload.distanceM, sourceLabel || 'target QR code');
          } else if (payload.presetKey){
            setStatus(`Reference markers set to ${(PRESETS[payload.presetKey] || {}).label} from the target QR code.`);
          }
        }

        /* Native-resolution corner crops (30% x 22%) taken BEFORE the bitmap is closed.
           On a whole-sheet photo the corner QR is ~100 px in the 1600 px working copy;
           BarcodeDetector wants it >= ~300 px, so each crop is upscaled (no smoothing).
           Terra-Build prints carry the QR top-right, so that crop is tried first. */
        function captureQrCorners(src, w, h){
          try {
            if (!src || !w || !h) return null;
            const cw = Math.round(w * 0.30), ch = Math.round(h * 0.22);
            if (cw < 40 || ch < 40) return null;
            const pts = [[w - cw, 0], [0, 0], [w - cw, h - ch], [0, h - ch]];
            const out = [];
            for (let i = 0; i < pts.length; i++){
              const cv = document.createElement('canvas');
              cv.width = cw; cv.height = ch;
              cv.getContext('2d').drawImage(src, pts[i][0], pts[i][1], cw, ch, 0, 0, cw, ch);
              out.push(cv);
            }
            return out;
          } catch(_){ return null; }
        }

        function upscaleForQr(cv){
          try {
            const m = Math.min(cv.width, cv.height);
            if (m >= 1600) return cv;
            const up = Math.min(6, Math.ceil(1600 / Math.max(1, m)));
            if (up <= 1) return cv;
            const big = document.createElement('canvas');
            big.width = cv.width * up; big.height = cv.height * up;
            const ctx = big.getContext('2d');
            ctx.imageSmoothingEnabled = false;
            ctx.drawImage(cv, 0, 0, big.width, big.height);
            return big;
          } catch(_){ return cv; }
        }

        function tryDistanceQrScan(primary, extras){
          const done = () => { state._qrCrops = null; };
          if (typeof window === 'undefined' || !('BarcodeDetector' in window)) { done(); return; }
          let detector;
          try { detector = new window.BarcodeDetector({ formats: ['qr_code'] }); }
          catch(_){ done(); return; }
          const cands = [primary].concat(extras || []).filter(Boolean);
          let idx = 0;
          const next = () => {
            if (idx >= cands.length) { done(); return; }
            let cv = cands[idx++];
            if (idx > 1) cv = upscaleForQr(cv);
            let p;
            try { p = detector.detect(cv); }
            catch(_){ next(); return; }
            if (!p || typeof p.then !== 'function') { next(); return; }
            p.then((codes) => {
              if (codes && codes.length){
                for (let i = 0; i < codes.length; i++){
                  const payload = parseTargetQrPayload(codes[i].rawValue || '');
                  if (payload){
                    applyQrPayload(payload, 'target QR code');
                    done();
                    return;
                  }
                }
              }
              next();
            }).catch(next);
          };
          next();
        }

        function loadImageFromFile(file){
          if (!file) return;
          resetWorkingState();

          // V25-D: createImageBitmap with imageOrientation:'from-image'
          // honours phone EXIF orientation; falls back to <img> pipeline.
          const onDecoded = (bitmapOrImage, naturalWidth, naturalHeight) => {
            const maxDim = 1600;
            const w = naturalWidth || bitmapOrImage.width;
            const h = naturalHeight || bitmapOrImage.height;
            const scale = Math.min(1, maxDim / Math.max(w, h));
            els.sourceCanvas.width = Math.round(w * scale);
            els.sourceCanvas.height = Math.round(h * scale);
            const ctx = els.sourceCanvas.getContext('2d', { willReadFrequently: true });
            ctx.drawImage(bitmapOrImage, 0, 0, els.sourceCanvas.width, els.sourceCanvas.height);
            state.lastSourceImageDataUrl = els.sourceCanvas.toDataURL('image/jpeg', 0.92);
            state._qrCrops = captureQrCorners(bitmapOrImage, w, h);   // V67: before close()
            if (bitmapOrImage.close) { try { bitmapOrImage.close(); } catch(_){} }
            drawSourcePreview();
            // V59: best-effort QR scan to auto-fill distance (V67: + preset, corner crops).
            tryDistanceQrScan(els.sourceCanvas, state._qrCrops);
            setStatus(`Photo loaded. Detecting ${getPreset().label} reference markers…`);
            setTimeout(detectMarkersFromNewImage, 50);
          };

          const fallbackLoadViaImage = () => {
            const url = URL.createObjectURL(file);
            const img = new Image();
            img.onload = () => {
              onDecoded(img, img.width, img.height);
              URL.revokeObjectURL(url);
            };
            img.onerror = () => {
              URL.revokeObjectURL(url);
              setStatus('Could not decode the selected image. Please try a different photo.');
            };
            img.src = url;
          };

          if (typeof createImageBitmap === 'function'){
            try {
              const p = createImageBitmap(file, { imageOrientation: 'from-image' });
              if (p && typeof p.then === 'function'){
                p.then((bitmap) => onDecoded(bitmap, bitmap.width, bitmap.height))
                 .catch(fallbackLoadViaImage);
                return;
              }
            } catch (_){
              // fall through
            }
          }
          fallbackLoadViaImage();
        }


        function buildFallbackCorners(){
          const width = els.sourceCanvas.width;
          const height = els.sourceCanvas.height;
          if (!width || !height) return null;
          const padX = Math.max(24, Math.round(width * 0.08));
          const padY = Math.max(24, Math.round(height * 0.08));
          return [
            { x: padX, y: padY },
            { x: width - padX, y: padY },
            { x: width - padX, y: height - padY },
            { x: padX, y: height - padY }
          ];
        }

        // V32: rotate the loaded source photo 90deg clockwise. Used when
        // a phone's EXIF orientation tag is missing or wrong and the
        // photo lands sideways in the canvas. Resets all detection state
        // (corners, shots, rectified) and re-runs marker detection on
        // the rotated image.
        function rotateSourcePhoto(){
          const src = els.sourceCanvas;
          if (!src.width || !src.height){
            setStatus('Load a target photo before rotating.');
            return;
          }
          const w = src.width, h = src.height;
          const tmp = document.createElement('canvas');
          tmp.width = h;
          tmp.height = w;
          const tctx = tmp.getContext('2d');
          // Rotate 90 degrees clockwise: translate then rotate, then draw.
          tctx.translate(h, 0);
          tctx.rotate(Math.PI / 2);
          tctx.drawImage(src, 0, 0);
          // Resize the source canvas to the rotated dimensions and copy.
          src.width = h;
          src.height = w;
          const sctx = src.getContext('2d', { willReadFrequently: true });
          sctx.drawImage(tmp, 0, 0);
          state.lastSourceImageDataUrl = src.toDataURL('image/jpeg', 0.92);
          // Reset detection-derived state so we re-run cleanly on the
          // rotated geometry. Don't call resetWorkingState() because that
          // would also clear sourceCanvas, which we just rotated.
          state.manualCorners = [];
          state.placingManualMarkers = false;
          state.corners = null;
          state.baseCorners = null;
          state.shots = [];
          state.rectifiedBaseImageData = null;
          state.poiOffsetMm = { x: 0, y: 0 };
          state.sourceLocked = false;
          state.shotsDetected = false;
          state.coldBoreShotIndex = null;
          state.cornerScores = { tl: 0, tr: 0, br: 0, bl: 0 };
          state.cornerFound = { tl: false, tr: false, br: false, bl: false };
          state.cornerFromFallback = false;
          state.predictedCorner = null;
          state.fineTuneUserOverride = false;
          state.otsuThreshold = null;
          // Clear the rectified canvas so the previous rectification
          // doesn't keep showing while the user waits for re-detection.
          if (els.rectifiedCanvas && els.rectifiedCanvas.width){
            els.rectifiedCanvas.width = 0;
            els.rectifiedCanvas.height = 0;
          }
          resetFineTuneOffsets();
          syncCornerInputs();
          resetRectifiedViewport();
          updateThresholdReadout();
          updateCornerConfidenceBadges({ reset: true });
          updateMetrics();
          syncColdBoreUI();
          syncWorkflowVisibility();
          syncLockPill();
          drawSourcePreview();
          setStatus('Photo rotated. Re-detecting reference markers\u2026');
          setTimeout(detectMarkersFromNewImage, 50);
        }

        function detectMarkersFromNewImage(){
          const source = els.sourceCanvas;
          if (!source.width) return;
          setRerunButtonState('running');

          // V24: detectCornerMarkers now returns { corners, scores, found, geometryOk, predictedCorner }.
          const detection = detectCornerMarkers(source);
          state.cornerScores = detection.scores;
          state.cornerFound = detection.found;
          state.predictedCorner = detection.predictedCorner || null;

          if (!detection.corners){
            // At least one corner failed acceptance or geometry validation.
            state.cornerFromFallback = true;
            updateCornerConfidenceBadges();
            // V27: fallback means the user almost certainly needs to
            // fine-tune -- auto-expand the card unless they've already
            // manually toggled it this session.
            if (!state.fineTuneUserOverride){
              state.fineTuneCollapsed = false;
              syncFineTuneCollapseUI();
            }

            const fallback = buildFallbackCorners();
            state.corners = fallback;
            state.baseCorners = fallback.map((p) => ({ x: p.x, y: p.y }));
            state.manualCorners = fallback.map((p) => ({ x: p.x, y: p.y }));
            resetFineTuneOffsets();
            syncCornerInputs();
            drawSourcePreview(fallback);

            // Build a compact diagnostic string that names the weak corners.
            const labels = { tl: 'TL', tr: 'TR', br: 'BR', bl: 'BL' };
            const weak = [];
            ['tl','tr','br','bl'].forEach((k) => {
              if (!detection.found[k]) weak.push(labels[k]);
            });
            const detail = weak.length
              ? `${weak.join(', ')} below confidence threshold`
              : (detection.geometryOk ? 'geometry check failed' : 'quadrilateral shape invalid');
            setStatus(`Reference markers could not be identified automatically (${detail}). Default corner positions added — use the fine-tune controls to adjust, then lock the source.`);
            // V29: rectify with the fallback so the user can eyeball the
            // result, but DO NOT run shot detection yet -- the new flow
            // waits until the user locks the source and confirms the
            // expected shot count.
            renderFromCornersOnly(fallback);
            setRerunButtonState('idle');
            syncWorkflowVisibility();
            return;
          }

          // All four corners accepted (or three accepted + one predicted).
          state.cornerFromFallback = false;
          updateCornerConfidenceBadges();
          // V27: detection is reliable when all 4 are found natively
          // (no prediction). Collapse fine-tune to save mobile screen
          // space. If a corner was inferred, keep the card open so the
          // user can eyeball-verify with the stepper controls. Respect
          // any earlier manual toggle.
          if (!state.fineTuneUserOverride){
            if (detection.predictedCorner){
              state.fineTuneCollapsed = false;
            } else {
              state.fineTuneCollapsed = true;
            }
            syncFineTuneCollapseUI();
          }

          const foundCorners = detection.corners;
          state.baseCorners = foundCorners.map((p) => ({ x: p.x, y: p.y }));
          resetFineTuneOffsets();
          syncCornerInputs();
          // V25-A: status mentions the predicted corner so the user
          // knows to eyeball-check one side before trusting group size.
          const predictedMsg = detection.predictedCorner
            ? ` ${detection.predictedCorner.toUpperCase()} corner inferred from the other 3 — verify with fine-tune before locking.`
            : '';
          // V29: rectify only -- DO NOT run shot detection yet. The user
          // moves through Lock source -> Expected shots -> Detect shots
          // before we look for bullet holes.
          setStatus(`Reference markers found. Rectified target ready — lock the source if it looks right, otherwise fine-tune the corners.${predictedMsg}`);
          renderFromCornersOnly(foundCorners);
          setRerunButtonState('idle');
          syncWorkflowVisibility();
        }

        function getRectifiedEventPoint(e){
          const point = (e.touches && e.touches[0]) ? e.touches[0] : e;
          return { x: point.clientX, y: point.clientY };
        }

        function getTouchDistance(touches){
          if (!touches || touches.length < 2) return 0;
          const dx = touches[0].clientX - touches[1].clientX;
          const dy = touches[0].clientY - touches[1].clientY;
          return Math.hypot(dx, dy);
        }

        function zoomRectified(nextZoom, anchorClientX, anchorClientY){
          const canvas = els.rectifiedCanvas;
          if (!canvas.width) return;
          const prevZoom = Number(state.rectifiedZoom || 1);
          const clampedZoom = Math.max(1, Math.min(5, nextZoom));
          if (Math.abs(clampedZoom - prevZoom) < 0.001) return;
          const rect = canvas.getBoundingClientRect();
          /* 2026-08-16: anchored-zoom fix (same defect fixed in Terra-Confirm v1.0.63).
             Two stacked faults made pinch/wheel zoom slide the point of interest away:
             (1) the pan-update sign was inverted (+anchor drives the anchored point AWAY);
             (2) the anchor was measured against the rectified canvas own getBoundingClientRect,
                 which is the TRANSFORMED box (centre = layoutCentre + pan), while the
                 pan*ratio - anchor*(ratio-1) update needs the untransformed-centre frame.
                 Adding the current pan converts the measurement. Wheel + pinch both land here. */
          const anchorX = isFinite(anchorClientX) ? (anchorClientX - rect.left - (rect.width / 2) + Number(state.rectifiedPan.x || 0)) : 0;
          const anchorY = isFinite(anchorClientY) ? (anchorClientY - rect.top - (rect.height / 2) + Number(state.rectifiedPan.y || 0)) : 0;
          const scaleRatio = clampedZoom / prevZoom;
          state.rectifiedPan.x = (Number(state.rectifiedPan.x || 0) * scaleRatio) - (anchorX * (scaleRatio - 1));
          state.rectifiedPan.y = (Number(state.rectifiedPan.y || 0) * scaleRatio) - (anchorY * (scaleRatio - 1));
          state.rectifiedZoom = clampedZoom;
          applyRectifiedViewport();
          queueBrowserAutoSave();
        }

        function startRectifiedPan(point){
          state.isPanningRectified = true;
          state.lastPanPoint = { x: point.x, y: point.y };
          syncLockRectifiedUI();
        }

        function moveRectifiedPan(point){
          if (!state.isPanningRectified || !state.lastPanPoint) return;
          state.rectifiedPan.x += point.x - state.lastPanPoint.x;
          state.rectifiedPan.y += point.y - state.lastPanPoint.y;
          state.lastPanPoint = { x: point.x, y: point.y };
          applyRectifiedViewport();
        }

        function endRectifiedPan(){
          if (!state.isPanningRectified && !state.lastPanPoint) return;
          state.isPanningRectified = false;
          state.lastPanPoint = null;
          syncLockRectifiedUI();
          queueBrowserAutoSave();
        }

        function applyRectifiedShotEditFromPoint(clientX, clientY){
          const canvas = els.rectifiedCanvas;
          if (!canvas.width) return;

          const rect = canvas.getBoundingClientRect();
          const x = ((clientX - rect.left) / rect.width) * canvas.width;
          const y = ((clientY - rect.top) / rect.height) * canvas.height;

          if (state.editMode === 'place'){
            state.shots.push({x,y});
            haptic('place');
            // V34: if the user is hand-placing the first shot, that shot
            // automatically becomes the cold-bore.
            ensureColdBoreDefault();
            syncColdBoreUI();
            redrawRectifiedOverlay();
            updateMetrics();
            setStatus('Shot placed.');
          } else {
            let hit = null, best = 36;
            state.shots.forEach((s,i) => {
              const d = Math.hypot(s.x-x, s.y-y);
              if (d < best) { best = d; hit = i; }
            });
            if (hit == null){
              setStatus('No shot selected. Tap closer to a shot circle.');
              return;
            }
            state.shots.splice(hit, 1);
            // V34: re-anchor the cold-bore to a valid shot after delete.
            // If the deleted shot was the cold-bore, fall back to shot 0.
            // If the deleted index was below the cold-bore, slide down.
            if (state.coldBoreShotIndex != null){
              if (state.coldBoreShotIndex === hit){
                state.coldBoreShotIndex = state.shots.length > 0 ? 0 : null;
              } else if (state.coldBoreShotIndex > hit){
                state.coldBoreShotIndex -= 1;
              }
              syncColdBoreUI();
            }
            haptic('delete');
            if (state.shots.length === 0){
              state.editMode = 'place';
              syncEditButton();
              redrawRectifiedOverlay();
              updateMetrics();
              setStatus('Shot removed. No shots left, switched back to Add shot.');
              return;
            }
            redrawRectifiedOverlay();
            updateMetrics();
            setStatus('Shot removed.');
          }
        }

        function handleRectifiedPointerDown(e){
          const canvas = els.rectifiedCanvas;
          if (!canvas.width) return;
          if (typeof e.button === 'number' && e.button !== 0) return;
          const point = getRectifiedEventPoint(e);
          state.rectifiedPointerDown = { x: point.x, y: point.y, clientX: e.clientX, clientY: e.clientY };
          state.rectifiedPointerMoved = false;
          state.rectifiedPointerId = typeof e.pointerId === 'number' ? e.pointerId : null;
          if (state.lockRectified) {
            startRectifiedPan(point);
            if (e.cancelable) e.preventDefault();
            return;
          }
          if (Number(state.rectifiedZoom || 1) > 1.001 && canvas.setPointerCapture && typeof e.pointerId === 'number') {
            try { canvas.setPointerCapture(e.pointerId); } catch (err) {}
          }
        }

        function handleRectifiedPointerMove(e){
          const point = getRectifiedEventPoint(e);
          const isZoomed = Number(state.rectifiedZoom || 1) > 1.001;
          if (state.lockRectified) {
            moveRectifiedPan(point);
            if (state.isPanningRectified && e.cancelable) e.preventDefault();
            return;
          }
          if (!state.rectifiedPointerDown || (state.rectifiedPointerId != null && typeof e.pointerId === 'number' && e.pointerId !== state.rectifiedPointerId)) return;
          const dx = point.x - state.rectifiedPointerDown.x;
          const dy = point.y - state.rectifiedPointerDown.y;
          const moved = Math.hypot(dx, dy);
          if (isZoomed && moved > 6) {
            if (!state.isPanningRectified) startRectifiedPan(point);
            state.rectifiedPointerMoved = true;
            moveRectifiedPan(point);
            if (e.cancelable) e.preventDefault();
          }
        }

        function handleRectifiedPointerUp(e){
          const wasPanning = !!state.isPanningRectified;
          const wasMoved = !!state.rectifiedPointerMoved;
          const downPoint = state.rectifiedPointerDown;
          endRectifiedPan();
          state.rectifiedPointerDown = null;
          state.rectifiedPointerMoved = false;
          state.rectifiedPointerId = null;
          if (state.lockRectified) {
            if (e.cancelable) e.preventDefault();
            return;
          }
          if (!wasPanning && !wasMoved && downPoint) {
            applyRectifiedShotEditFromPoint(e.clientX, e.clientY);
            if (e.cancelable) e.preventDefault();
          }
        }

        function adjustFineTuneInput(inputId, direction){
          const input = document.getElementById(inputId);
          if (!input) return;
          const step = Number(input.step) || 1;
          const current = Number(input.value);
          const next = (isFinite(current) ? current : 0) + (step * direction);
          input.value = String(Math.round(next));
          input.dispatchEvent(new Event('input', { bubbles: true }));
        }

        root.addEventListener('click', (event) => {
          const btn = event.target.closest('[data-corner-input][data-step-dir]');
          if (!btn) return;
          event.preventDefault();
          adjustFineTuneInput(btn.getAttribute('data-corner-input'), Number(btn.getAttribute('data-step-dir')) || 0);
        });

        /* V64: Fine-tune corner selector + directional pad. */
        const FT_CORNERS = ['tl','tr','br','bl'];
        let selectedFineTuneCorner = 'tl';

        function syncFineTuneCornerSelection(){
          root.querySelectorAll('[data-corner-select]').forEach((btn) => {
            const isActive = btn.getAttribute('data-corner-select') === selectedFineTuneCorner;
            btn.classList.toggle('is-active', isActive);
            btn.setAttribute('aria-checked', isActive ? 'true' : 'false');
          });
        }
        function updateFineTuneReadout(){
          const sel = selectedFineTuneCorner.toUpperCase();
          const xInput = document.getElementById(`corner${sel}X-${sectionId}`);
          const yInput = document.getElementById(`corner${sel}Y-${sectionId}`);
          const xOut = document.getElementById(`finetuneReadoutX-${sectionId}`);
          const yOut = document.getElementById(`finetuneReadoutY-${sectionId}`);
          if (xOut && xInput) xOut.textContent = String(xInput.value || '0');
          if (yOut && yInput) yOut.textContent = String(yInput.value || '0');
        }
        function setSelectedFineTuneCorner(corner){
          if (FT_CORNERS.indexOf(corner) === -1) return;
          selectedFineTuneCorner = corner;
          syncFineTuneCornerSelection();
          updateFineTuneReadout();
        }

        /* Corner pill click: switch which corner the pad operates on. */
        root.addEventListener('click', (event) => {
          const cornerBtn = event.target.closest('[data-corner-select]');
          if (!cornerBtn) return;
          event.preventDefault();
          setSelectedFineTuneCorner(cornerBtn.getAttribute('data-corner-select'));
        });

        /* Pad direction -> axis dispatch: up/down=Y±1, left/right=X±1 */
        root.addEventListener('click', (event) => {
          const padBtn = event.target.closest('[data-pad-dir]');
          if (!padBtn) return;
          event.preventDefault();
          const dir = padBtn.getAttribute('data-pad-dir');
          const sel = selectedFineTuneCorner.toUpperCase();
          const xId = `corner${sel}X-${sectionId}`;
          const yId = `corner${sel}Y-${sectionId}`;
          if (dir === 'up')         adjustFineTuneInput(yId, -1);
          else if (dir === 'down')  adjustFineTuneInput(yId,  1);
          else if (dir === 'left')  adjustFineTuneInput(xId, -1);
          else if (dir === 'right') adjustFineTuneInput(xId,  1);
        });

        /* Readout sync on any input change (covers reset, restore, pad clicks) */
        FT_CORNERS.forEach((c) => {
          ['X','Y'].forEach((axis) => {
            const inp = document.getElementById(`corner${c.toUpperCase()}${axis}-${sectionId}`);
            if (inp) inp.addEventListener('input', updateFineTuneReadout);
          });
        });
        updateFineTuneReadout();

        if (els.saveSessionBtn) {
          els.saveSessionBtn.addEventListener('click', downloadSessionFile);
        }
        if (els.loadSessionInput) {
          els.loadSessionInput.addEventListener('change', (e) => {
            loadSessionFromFile(e.target.files && e.target.files[0]);
            e.target.value = '';
          });
        }
        // V26: two separate <input type=file> elements -- one for the
        // photo library (fileInput) and one for the camera (cameraInput,
        // with the capture="environment" attribute). The labels wrapping
        // each input click them natively, so no JS click bridge is
        // needed. Resetting .value after each load lets the user pick
        // the SAME file again and still have the change event fire.
        function onFilePicked(e){
          const file = e.target.files && e.target.files[0];
          e.target.value = '';
          loadImageFromFile(file);
        }
        els.fileInput.addEventListener('change', onFilePicked);
        if (els.cameraInput){
          els.cameraInput.addEventListener('change', onFilePicked);
        }
        els.threshold.addEventListener('input', () => {
          // V24: slider now represents a ±offset around the Otsu-auto
          // threshold. Update the readout immediately; debounce the
          // actual detection pass to avoid thrashing while the user drags.
          updateThresholdReadout();
          if (state.lockRectified) return;
          if (!state.rectifiedBaseImageData) return;
          // V29: don't auto-rerun until the user has explicitly run
          // detection at least once \u2014 prevents the slider from
          // triggering shot detection during the new pre-lock workflow.
          if (!state.shotsDetected) return;
          if (state.shotDetectionTimer) clearTimeout(state.shotDetectionTimer);
          state.shotDetectionTimer = setTimeout(() => {
            setRerunButtonState('running');
            rerunShotDetection('Rectified target ready.');
          }, 220);
        });

        if (els.lockRectified) {
          els.lockRectified.addEventListener('change', () => {
            setLockRectified(!!els.lockRectified.checked);
            setStatus(state.lockRectified ? 'Rectified target locked for zoom / pan.' : 'Rectified target unlocked. Zoom remains available.');
          });
        }
        els.distanceM.addEventListener('input', () => {
          // V59: typing drops the auto-filled / required cues then
          // updates metrics + triggers autosave.
          els.distanceM.classList.remove('is-auto-filled');
          els.distanceM.classList.remove('is-required-empty');
          updateMetrics();
          queueBrowserAutoSave();
        });

        // V35: dual Add / Delete buttons drive state.editMode directly.
        if (els.addShotBtn){
          els.addShotBtn.addEventListener('click', () => {
            if (state.lockRectified) return;
            state.editMode = 'place';
            syncEditButton();
            setStatus('Add shot mode active. Click the rectified target to place a shot.');
          });
        }
        if (els.deleteShotBtn){
          els.deleteShotBtn.addEventListener('click', () => {
            if (state.lockRectified) return;
            state.editMode = 'remove';
            syncEditButton();
            setStatus('Delete shot mode active. Click an existing shot to remove it.');
          });
        }
        // Legacy single-toggle, only fires if the older theme is in use.
        if (els.editBtn){
          els.editBtn.addEventListener('click', () => {
            if (state.lockRectified) return;
            state.editMode = state.editMode === 'place' ? 'remove' : 'place';
            syncEditButton();
            setStatus(state.editMode === 'place' ? 'Add shot mode active. Click the rectified target to place a shot.' : 'Delete shot mode active. Click an existing shot to remove it.');
          });
        }

        els.clearShotsBtn.addEventListener('click', () => {
          if (state.lockRectified) return;
          state.shots = [];
          state.editMode = 'place';
          syncEditButton();
          redrawRectifiedOverlay();
          updateMetrics();
          setStatus('Shots cleared.');
        });

        if (els.exportCsvBtn){
          els.exportCsvBtn.addEventListener('click', downloadShotsCsv);
        }

        els.rectifiedCanvas.addEventListener('pointerdown', handleRectifiedPointerDown);
        els.rectifiedCanvas.addEventListener('pointermove', handleRectifiedPointerMove);
        window.addEventListener('pointerup', handleRectifiedPointerUp);
        window.addEventListener('pointercancel', () => {
          endRectifiedPan();
          state.rectifiedPointerDown = null;
          state.rectifiedPointerMoved = false;
          state.rectifiedPointerId = null;
        });
        if (els.rectifiedWrap) {
          els.rectifiedWrap.addEventListener('wheel', (e) => {
            e.preventDefault();
            const nextZoom = Number(state.rectifiedZoom || 1) * (e.deltaY < 0 ? 1.12 : 0.9);
            zoomRectified(nextZoom, e.clientX, e.clientY);
          }, { passive: false });
        }
        // V25: touch handlers cover multi-touch pinch-zoom only;
        // single-touch tap/drag is delegated to pointer events.
        els.rectifiedCanvas.addEventListener('touchstart', (e) => {
          if (e.touches.length >= 2) {
            state.pinchDistance = getTouchDistance(e.touches);
            // Clear any pending pointer-down so pointer-up won't fire.
            state.isPanningRectified = false;
            state.lastPanPoint = null;
            state.rectifiedPointerDown = null;
            state.rectifiedPointerMoved = true;
            if (e.cancelable) e.preventDefault();
          }
        }, { passive: false });
        els.rectifiedCanvas.addEventListener('touchmove', (e) => {
          if (e.touches.length >= 2) {
            const nextDistance = getTouchDistance(e.touches);
            if (state.pinchDistance > 0 && nextDistance > 0) {
              const midpointX = (e.touches[0].clientX + e.touches[1].clientX) / 2;
              const midpointY = (e.touches[0].clientY + e.touches[1].clientY) / 2;
              const ratio = nextDistance / state.pinchDistance;
              zoomRectified(Number(state.rectifiedZoom || 1) * ratio, midpointX, midpointY);
            }
            state.pinchDistance = nextDistance;
            if (e.cancelable) e.preventDefault();
          }
        }, { passive: false });
        els.rectifiedCanvas.addEventListener('touchend', (e) => {
          if (e.touches.length < 2) {
            state.pinchDistance = 0;
          }
        }, { passive: false });

        els.resetFineTuneBtn.addEventListener('click', () => {
          resetFineTuneOffsets();
          syncCornerInputs();
          if (state.baseCorners && state.baseCorners.length === 4) {
            state.manualCorners = state.baseCorners.map((p) => ({ x: p.x, y: p.y }));
            state.corners = state.manualCorners.slice();
            drawSourcePreview(state.manualCorners);
            // V29: rectify only \u2014 the user re-runs detection after
            // they've re-locked the source.
            renderFromCornersOnly(state.manualCorners.slice());
            if (state.shotsDetected || state.shots.length){
              state.shots = [];
              state.shotsDetected = false;
              state.coldBoreShotIndex = null;
              redrawRectifiedOverlay();
              updateMetrics();
              syncColdBoreUI();
            }
            syncWorkflowVisibility();
          } else {
            drawSourcePreview(state.manualCorners.length === 4 ? state.manualCorners : null);
          }
          setStatus('Corner offsets reset to 0 mm.');
        });
        if (els.fineTuneToggleBtn) {
          els.fineTuneToggleBtn.addEventListener('click', () => {
            state.fineTuneCollapsed = !state.fineTuneCollapsed;
            // V27: user taps = user choice -- don't auto-override later.
            state.fineTuneUserOverride = true;
            syncFineTuneCollapseUI();
            queueBrowserAutoSave();
          });
        }
        els.cornerInputs.forEach((pair) => {
          [pair.x, pair.y].forEach((input) => {
            input.addEventListener('input', () => {
              syncFineTuneOffsetsFromInputs();
              applyFineTuneAndProcess(true);
              if (state.fineTuneAutoTimer) clearTimeout(state.fineTuneAutoTimer);
              state.fineTuneAutoTimer = setTimeout(() => {
                applyFineTuneAndProcess(false);
              }, 180);
            });
          });
        });

        els.transferBtn.addEventListener('click', () => {
          /* V65: send metres to Terra-Dial regardless of UI units */
          const distanceM = getDistanceMetres();
          if (!distanceM || state.shots.length < 1) {
            setStatus('Add distance and detect at least one shot before opening Terra-Dial.');
            return;
          }
          // V36: send BOTH the group POI and the cold-bore POI (if any)
          // to Terra-Dial so the user can flip between them on that page.
          // The "source" param is Terra-Impact's recommended default \u2014
          // group POI when the user has multiple shots and no-cold-bore
          // is off, otherwise the cold-bore offset itself.
          const groupX = state.poiOffsetMm.x || 0;
          const groupY = state.poiOffsetMm.y || 0;
          const cb = state.coldBorePoiOffsetMm;
          const hasColdBore = !state.noColdBore && cb && isFinite(cb.x) && isFinite(cb.y);

          // Pick which set drives the legacy single-POI fields (so old
          // Terra-Dial builds without source-switching still see something
          // sensible). Default = group; if there's only ONE shot, that
          // shot is both the group and the cold-bore so prefer cold-bore
          // labelling for the user-facing source param.
          const preferColdBore = hasColdBore && state.shots.length === 1;
          const primaryX = preferColdBore ? cb.x : groupX;
          const primaryY = preferColdBore ? cb.y : groupY;

          const verticalMm = Math.abs(primaryY);
          const horizontalMm = Math.abs(primaryX);
          const verticalDirection = primaryY >= 0 ? 'low' : 'high';
          const horizontalDirection = primaryX >= 0 ? 'right' : 'left';
          const baseUrl = cfg.transferUrl;
          const url = new URL(baseUrl, window.location.origin);
          url.searchParams.set('distance', formatNumber(distanceM, 2));
          url.searchParams.set('distance_m', formatNumber(distanceM, 2));
          url.searchParams.set('vertical_offset', formatNumber(verticalMm, 2));
          url.searchParams.set('vertical_offset_mm', formatNumber(verticalMm, 2));
          url.searchParams.set('vertical_direction', verticalDirection);
          url.searchParams.set('horizontal_offset', formatNumber(horizontalMm, 2));
          url.searchParams.set('horizontal_offset_mm', formatNumber(horizontalMm, 2));
          url.searchParams.set('horizontal_direction', horizontalDirection);
          // Group POI (signed mm). Always populated.
          url.searchParams.set('poi_x_mm', formatNumber(groupX, 2));
          url.searchParams.set('poi_y_mm', formatNumber(groupY, 2));
          url.searchParams.set('x_offset', formatNumber(groupX, 2));
          url.searchParams.set('y_offset', formatNumber(groupY, 2));
          // V36: shot count for context in Terra-Dial UI.
          url.searchParams.set('shot_count', String(state.shots.length));
          // V36: cold-bore POI (signed mm) and a "source" hint.
          if (hasColdBore){
            url.searchParams.set('cold_bore_x_mm', formatNumber(cb.x, 2));
            url.searchParams.set('cold_bore_y_mm', formatNumber(cb.y, 2));
            url.searchParams.set('cold_bore_shot', String((state.coldBoreShotIndex || 0) + 1));
            url.searchParams.set('source', preferColdBore ? 'coldbore' : 'group');
          } else {
            url.searchParams.set('source', 'group');
          }
          window.location.href = url.toString();
        });

        /* V66: end-of-flow handoff to the Terra-Confirm app. Encodes the
           detected shots (mm relative to point of aim = rectified canvas
           centre) + distance + optional cold-bore index as a base64url
           JSON payload and navigates to Terra-Confirm, which offers to
           save it against a rifle.

           Contract (must match Terra-Confirm detectInboundAnalysis):
             { v:1, src:'impact', distM:<number>, units:'m',
               shots:[[xMm,yMm],...], cbIndex:<int|absent> }
           cbIndex is the 0-based index of the cold-bore shot, included
           only when the user has tagged one and not toggled "no
           cold-bore". */
        function handoffToConfirm(){
          try {
            const distanceM = getDistanceMetres();
            if (!distanceM || state.shots.length < 1){
              setStatus('Add distance and detect at least one shot before sending to Terra-Confirm.');
              return;
            }
            const pxPerMm = getPixelsPerMm();
            const canvas = els.rectifiedCanvas;
            if (!pxPerMm || !isFinite(pxPerMm) || !canvas.width || !canvas.height){
              setStatus('Rectify the target before sending to Terra-Confirm.');
              return;
            }
            const aimX = canvas.width / 2;
            const aimY = canvas.height / 2;
            const shots = state.shots.map((s) => [
              (s.x - aimX) / pxPerMm,
              (s.y - aimY) / pxPerMm
            ]).filter((p) => isFinite(p[0]) && isFinite(p[1]));
            if (!shots.length){
              setStatus('No valid shots to send.');
              return;
            }
            const payload = { v:1, src:'impact', units:'m', distM: distanceM, shots: shots };
            // Carry the cold-bore tag through when the user has set one.
            const hasColdBore = !state.noColdBore
              && state.coldBoreShotIndex != null
              && state.coldBoreShotIndex >= 0
              && state.coldBoreShotIndex < shots.length;
            if (hasColdBore){
              payload.cbIndex = state.coldBoreShotIndex;
            }
            const json = JSON.stringify(payload);
            const b64 = btoa(unescape(encodeURIComponent(json)))
              .replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
            const base = CONFIRM_URL || '/pages/terra-confirm';
            const sep = base.indexOf('?') === -1 ? '?' : '&';
            window.location.href = base + sep + 'tcfm_import=' + b64;
          } catch (e) {
            console.warn('[Terra-Impact] handoff to Terra-Confirm failed', e);
          }
        }
        if (els.saveToConfirmBtn){
          els.saveToConfirmBtn.addEventListener('click', handoffToConfirm);
        }

        // V27: preset segmented control. Each button carries data-preset
        // with the PRESETS key. Click switches the preset, re-runs
        // detection with the current corners (if any), and persists the
        // choice to localStorage so the next visit remembers it.
        const PRESET_STORAGE_KEY = `terra-impact-preset`;
        function applyPresetChange(nextKey){
          if (!PRESETS[nextKey] || nextKey === state.presetKey) {
            // Still save in case it's the init restoration for an
            // already-active preset.
            try { localStorage.setItem(PRESET_STORAGE_KEY, nextKey); } catch(_){}
            return;
          }
          state.presetKey = nextKey;
          syncPresetUI();
          try { localStorage.setItem(PRESET_STORAGE_KEY, nextKey); } catch(_){}
          if (els.sourceCanvas.width) {
            // V29: changing the preset = changing physical scale. Reset
            // workflow stage so the user re-confirms lock + expected
            // shots before detection runs again.
            state.shots = [];
            state.rectifiedBaseImageData = null;
            state.shotsDetected = false;
            state.sourceLocked = false;
            state.coldBoreShotIndex = null;
            resetRectifiedViewport();
            setStatus(`Preset changed to ${getPreset().label}. Re-rectifying with current corner positions \u2014 lock the source and confirm expected shots to detect again.`);
            if (state.manualCorners && state.manualCorners.length === 4) {
              renderFromCornersOnly(state.manualCorners.slice());
            }
          }
          syncColdBoreUI();
          syncWorkflowVisibility();
          updateMetrics();
        }
        function manualPresetClick(presetKey){
          applyPresetChange(presetKey);
        }
        if (els.presetSelect){
          els.presetSelect.addEventListener('change', () => {
            manualPresetClick(els.presetSelect.value);
          });
        }

        // V27: Advanced card toggle -- same pattern as the fine-tune toggle.
        if (els.advancedToggleBtn && els.advancedCard){
          els.advancedToggleBtn.addEventListener('click', () => {
            state.advancedCollapsed = !state.advancedCollapsed;
            state.advancedUserOverride = true;
            syncAdvancedCollapseUI();
          });
        }

        // V28: expected-shots input. Fires on every input so the mismatch
        // badge tracks keystroke-by-keystroke. Empty value = null (badge off).
        // Persists per-section so the same user's typical round count
        // (e.g. a 5-round zeroing group) survives reloads.
        const EXPECTED_STORAGE_KEY = `terra-impact-expected-${sectionId}`;
        if (els.expectedShots){
          els.expectedShots.addEventListener('input', () => {
            const raw = els.expectedShots.value;
            if (raw === '' || raw == null){
              state.expectedShots = null;
              try { localStorage.removeItem(EXPECTED_STORAGE_KEY); } catch(_){}
            } else {
              const n = parseInt(raw, 10);
              if (isFinite(n) && n >= 0 && n <= 99){
                state.expectedShots = n;
                try { localStorage.setItem(EXPECTED_STORAGE_KEY, String(n)); } catch(_){}
              } else {
                state.expectedShots = null;
              }
            }
            // Reset the "last mismatch state" memo so the match haptic
            // fires once on the next transition, not immediately.
            state.lastMismatchState = null;
            updateMetrics();
          });
        }

        // V28: mini-metrics bar scroll visibility. Passive listener keeps
        // the scroll perf cost at zero on every browser that supports it
        // (all modern ones). Resize also fires so the viewport-width gate
        // re-evaluates when rotating the phone.
        if (!state.miniMetricsScrollBound){
          window.addEventListener('scroll', updateMiniMetricsVisibility, { passive: true });
          window.addEventListener('resize', updateMiniMetricsVisibility, { passive: true });
          // The header changes height with no scroll event (logo shrink
          // transition, announcement bar, drawer), so watch it directly.
          const hdr = document.querySelector('.section-header');
          if (hdr && typeof ResizeObserver === 'function'){
            new ResizeObserver(updateMiniMetricsVisibility).observe(hdr);
          }
          state.miniMetricsScrollBound = true;
        }

        // V29: new workflow event wiring

        // Lock-source toggle button.
        if (els.lockSourceBtn) {
          els.lockSourceBtn.addEventListener('click', () => {
            // If we don't have rectified output yet, force a render first.
            if (!state.rectifiedBaseImageData
                && state.manualCorners && state.manualCorners.length === 4) {
              renderFromCornersOnly(state.manualCorners.slice());
            }
            setSourceLocked(!state.sourceLocked);
          });
        }

        // V32: rotate-source button \u2014 90deg clockwise re-detection.
        if (els.rotateSourceBtn) {
          els.rotateSourceBtn.addEventListener('click', () => {
            rotateSourcePhoto();
          });
        }

        // Detect-shots button (the new explicit trigger).
        if (els.detectShotsBtn) {
          els.detectShotsBtn.addEventListener('click', () => {
            // V35: rectified-canvas lock also gates detection so the user
            // doesn\u2019t accidentally re-run while in measurement mode.
            if (state.lockRectified) {
              setStatus('Rectified target is locked. Unlock it before running shot detection.');
              return;
            }
            if (!state.rectifiedBaseImageData) {
              setStatus('Lock the source first so we can detect shots on the rectified target.');
              return;
            }
            setRerunButtonState('running');
            rerunShotDetection('Detecting shots.');
          });
        }

        // V34: Cold-bore button cycles through shots instead of entering
        // a tap-on-canvas tag mode.
        if (els.coldBoreBtn) {
          els.coldBoreBtn.addEventListener('click', cycleColdBoreShot);
        }
        // V35: "No cold bore" toggle.
        if (els.noColdBoreToggle){
          els.noColdBoreToggle.addEventListener('change', () => {
            state.noColdBore = !!els.noColdBoreToggle.checked;
            applyNoColdBore();
            queueBrowserAutoSave();
            setStatus(state.noColdBore
              ? 'Cold-bore tracking off for this group.'
              : 'Cold-bore tracking on. First shot tagged automatically.');
          });
        }

        // Lock pill (replaces the old Advanced checkbox).
        if (els.lockPill) {
          els.lockPill.addEventListener('click', () => {
            setLockRectified(!state.lockRectified);
            setStatus(state.lockRectified
              ? 'Rectified target locked for zoom / pan.'
              : 'Rectified target unlocked. Zoom remains available.');
          });
        }

        relocatePanels();
        window.addEventListener('resize', relocatePanels);
        window.addEventListener('beforeunload', saveBrowserSessionSilently);
        /* 2026-08-18 - REBUILD THE PICKER FROM PRESETS.
           The <select id="presetSelect-*"> options live in the Shopify SECTION
           MARKUP, not here, so swapping the table above would otherwise leave a
           dropdown still offering TT6-TT9: choosing one would resolve to
           undefined and getPreset() would quietly fall back to TT3 - the same
           silent-wrong-answer this change exists to remove. Rebuilding the
           options from PRESETS makes this asset self-sufficient, so the fix
           lands by uploading the asset alone and a stale liquid cannot
           reintroduce a dead code.
           The paper name is shown beside the code for the reason the app gives:
           eight near-identical codes in one list is exactly how someone sets
           TT15 (Letter landscape) on a TT11 (A4 landscape) sheet - 7% apart, so
           it measures happily and returns a plausible wrong answer. The paper
           name is the only thing checkable against the sheet in your hand.
           Display only; geometry stays in PRESETS and is never duplicated. */
        (function rebuildPresetOptions(){
          const sel = els.presetSelect;
          if (!sel) return;
          const PAPER = {
            TT10: 'A3 landscape',      TT11: 'A4 landscape',
            TT12: 'A3 portrait',       TT13: 'A4 portrait',
            TT14: 'Tabloid landscape', TT15: 'Letter landscape',
            TT16: 'Tabloid portrait',  TT17: 'Letter portrait'
          };
          try {
            sel.innerHTML = '';
            Object.keys(PRESETS).forEach((key) => {
              const label = PRESETS[key].label;
              const opt = document.createElement('option');
              opt.value = key;
              opt.textContent = PAPER[label] ? (label + ' · ' + PAPER[label]) : label;
              sel.appendChild(opt);
            });
          } catch(_){}
        })();

        // V27: restore remembered preset (BEFORE the first syncPresetUI so
        // the segmented control paints correctly). Silently fail on any
        // localStorage access error (private browsing, disabled storage).
        try {
          const saved = localStorage.getItem(PRESET_STORAGE_KEY);
          if (saved && PRESETS[saved]) state.presetKey = saved;
        } catch(_){}
        // V28: restore remembered expectedShots (BEFORE updateMetrics so
        // the mismatch badge paints correctly on first render).
        try {
          const savedExp = localStorage.getItem(EXPECTED_STORAGE_KEY);
          if (savedExp != null){
            const n = parseInt(savedExp, 10);
            if (isFinite(n) && n > 0 && n <= 99){
              state.expectedShots = n;
              if (els.expectedShots) els.expectedShots.value = String(n);
            }
          }
        } catch(_){}
        // V32: URL params override saved preset (so QR-style links land
        // on the right preset / distance straight away).
        applyUrlParams();

        /* V65: Unit system init. localStorage > Liquid default. */
        const __storedUnits = readStoredUnitSystem();
        if (__storedUnits && __storedUnits !== state.unitSystem){
          applyUnitSystem(__storedUnits, { save: false });
        }
        root.querySelectorAll('.terra-unit-segment[data-unit-system]').forEach(function(btn){
          btn.addEventListener('click', function(){ applyUnitSystem(btn.getAttribute('data-unit-system')); });
        });
        if (!window.__terraImpactUnitSystemBound){
          window.__terraImpactUnitSystemBound = true;
          window.addEventListener('storage', function(e){
            if (e.key === UNIT_SYSTEM_KEY && (e.newValue === 'imperial' || e.newValue === 'metric')){
              applyUnitSystem(e.newValue, { save: false });
            }
          });
        }
        // V34: per-card tip toggles. Each toggle button has a
        // data-tip-card identifier; we persist visibility per card and
        // default ALL of them to hidden.
        const TIP_STORAGE_KEY = `terra-impact-tips-${sectionId}`;
        function loadTipState(){
          try {
            const raw = localStorage.getItem(TIP_STORAGE_KEY);
            return raw ? JSON.parse(raw) : {};
          } catch(_){ return {}; }
        }
        function saveTipState(map){
          try { localStorage.setItem(TIP_STORAGE_KEY, JSON.stringify(map)); } catch(_){}
        }
        function applyTipVisibility(toggle, visible){
          const card = toggle.closest('.terra-card');
          if (!card) return;
          card.classList.toggle('tips-hidden', !visible);
          toggle.setAttribute('aria-pressed', visible ? 'true' : 'false');
          toggle.setAttribute('aria-label', visible ? 'Hide tips for this section' : 'Show tips for this section');
          toggle.setAttribute('title', visible ? 'Hide tips' : 'Show tips');
        }
        const tipToggles = root.querySelectorAll('.terra-tip-toggle[data-tip-card]');
        const savedTipState = loadTipState();
        tipToggles.forEach((toggle) => {
          const key = toggle.getAttribute('data-tip-card');
          // Default: hidden. Only restore "visible" if the user opted in
          // for that specific card.
          const visible = !!savedTipState[key];
          applyTipVisibility(toggle, visible);
          toggle.addEventListener('click', () => {
            const card = toggle.closest('.terra-card');
            const nowVisible = card ? card.classList.contains('tips-hidden') : true;
            applyTipVisibility(toggle, nowVisible);
            const map = loadTipState();
            map[key] = nowVisible;
            saveTipState(map);
            // V57: if the user opened the tip on a collapsed card,
            // the tip would render inside a hidden body and they\u2019d
            // see nothing change. Auto-expand through the existing
            // state machinery so the chevron / button animates and
            // autosave picks up the new collapse state. Covers both
            // the Advanced card and the Fine tune card (each has its
            // own collapsed flag + sync function).
            if (nowVisible && card && card.classList.contains('is-collapsed')){
              if (card === els.advancedCard){
                state.advancedCollapsed = false;
                syncAdvancedCollapseUI();
                queueBrowserAutoSave();
              } else if (card === els.fineTuneCard){
                state.fineTuneCollapsed = false;
                syncFineTuneCollapseUI();
                queueBrowserAutoSave();
              }
            }
          });
        });
        syncPresetUI();
        syncEditButton();
        syncManualMarkerUI();
        syncCornerInputs();
        syncLockRectifiedUI();
        // V29: initial paint of the new workflow elements.
        // V35: apply noColdBore root class + measurement-lock state on init
        // so the cold-bore POI cards / detect-shots disable mirror state.
        applyNoColdBore();
        syncMeasurementLockUI();
        syncColdBoreUI();
        syncLockPill();
        syncWorkflowVisibility();
        // V27: paint collapse states now so the default-closed cards
        // actually appear closed at first render (previously their
        // classList defaulted open and only flipped after first toggle).
        syncFineTuneCollapseUI();
        syncAdvancedCollapseUI();
        // V24: paint the new readouts in their empty state so the "--"
        // placeholders replace the raw HTML defaults on first render.
        updateThresholdReadout();
        updateCornerConfidenceBadges({ reset: true });
        setRerunButtonState('idle');
        updateMetrics();
        // V28: initial mini-metrics visibility check (bar stays hidden
        // until the user actually scrolls past the main metrics block,
        // so this just sets the baseline).
        updateMiniMetricsVisibility();
        loadBrowserSessionOnInit();

        /* V60: bfcache restore -- pageshow.persisted=true on Back/Forward */
        if (!window.__terraImpactPageshowBound){
          window.__terraImpactPageshowBound = true;
          window.addEventListener('pageshow', function(event){
            if (event.persisted){
              applyUrlParams();
              /* V65: re-read unit system in case another tab changed it */
              const stored = readStoredUnitSystem();
              if (stored && stored !== state.unitSystem) applyUnitSystem(stored, { save: false });
            }
          });
        }
      }

    /* V22: Vision mode toggle IIFE -- shared 'terra-vision-mode' localStorage. */      var STORAGE_KEY = 'terra-vision-mode';

      function initTerraImpactVisionMode(sectionId){
        var root = document.getElementById('terra-impact-' + sectionId);
        if (!root || root.dataset.terraVisionInit === 'true') return;
        root.dataset.terraVisionInit = 'true';

        function setMode(mode, save){
          var next = (mode === 'high-viz') ? 'high-viz' : 'standard';
          root.setAttribute('data-vision-mode', next);
          root.querySelectorAll('.terra-vision-segment[data-vision-mode]').forEach(function(btn){
            var isActive = btn.getAttribute('data-vision-mode') === next;
            btn.classList.toggle('is-active', isActive);
            btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
          });
          if (save !== false) {
            try { localStorage.setItem(STORAGE_KEY, next); } catch(e){}
          }
        }

        /* On init, restore saved preference (overrides Liquid default) */
        try {
          var saved = localStorage.getItem(STORAGE_KEY);
          if (saved === 'high-viz' || saved === 'standard') {
            setMode(saved, false);
          }
        } catch(e){}

        root.querySelectorAll('.terra-vision-segment[data-vision-mode]').forEach(function(btn){
          btn.addEventListener('click', function(){
            setMode(btn.getAttribute('data-vision-mode'));
          });
        });

        /* Listen for changes from other Terra tools open in other tabs */
        window.addEventListener('storage', function(e){
          if (e.key === STORAGE_KEY && (e.newValue === 'high-viz' || e.newValue === 'standard')) {
            setMode(e.newValue, false);
          }
        });
      }


  function initAll(){
    var REG = window.__terraImpactConfig || {};
    Object.keys(REG).forEach(function(sectionId){
      try { initTerraImpact(sectionId); } catch(e){ if (console && console.error) console.error('[terra-impact] init failed', sectionId, e); }
      try { initTerraImpactVisionMode(sectionId); } catch(e){ if (console && console.error) console.error('[terra-impact] vision-init failed', sectionId, e); }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function(event){
    var REG = window.__terraImpactConfig || {};
    Object.keys(REG).forEach(function(sectionId){
      var el = event.target && event.target.querySelector && event.target.querySelector('#terra-impact-' + sectionId);
      if (el) {
        initTerraImpact(sectionId);
        initTerraImpactVisionMode(sectionId);
      }
    });
  });

})();